import { isSawPaiban, judgeIsMergeFrameDoor } from '@/util/LayoutFuncs'
import ClipperLib from '@/util/clipper_unminified.js'
import {
  fourTrimEdge,
  getRotateObject,
  isSideMachineHole,
  isSideMachineMillInfo,
  isSideMachineSlot,
  rectToPath,
  toDecimal,
} from '@/util/commonFuncs'
import { getPlateKnifeDiameter } from '@/util/dealPaibanData'
import {
  closePath,
  dealEdgeInfoChange,
  dealFormerEdgeChange,
  dealPathToBasePoint,
  flipPath,
  getWHByPath,
  isLineSlotProcessPath,
  plankEdgeTransform,
  supplementBigPlankParam,
  toUpperPointPath,
} from '@/util/plankCommonFuncs'
import { cloneDeep } from 'lodash'

import store from '../store'
import {
  allocationHoleSlot,
  generatorSideHoleSlot, // layoutGap,
  // plankEdgeOff,
  cutKnifeRadius as layFunCutKnifeRadius,
  ncSettings,
  noRepeatPlankNum,
  specialSymbol,
  startPosition,
} from './LayoutFuncs.js'
import { matchMixPaibanPlan } from './common'
import { calculateSlantedRectanglePath, labelSources } from './commonFun'
import { dealPlankHoleSlotCSide } from './dealPaibanData.js'
import {
  dealLineSlotPath,
  expandPath,
  getExpandPathByArea,
} from './dealPlankDataFuncs'
import { dealPathCurve, getPathMinMax } from './dealThinkerxMaterialData'
import {
  compareNumbers,
  getClosestRectEdgeWithPoint,
  isPathStrictlyInside,
} from './graphCalc'
import { genLabelTextureGroups } from './plankAlignTexture'
import { recordTransform } from './recordTransform'

var roomName = ''
var roomID = ''
var ncConfig = {}
var plankWidth = ''
var plankHeight = ''
let sawDiameter = 0
export { ncConfig }
let layoutGap, plankEdgeOff, cutKnifeRadius
// 初始的拉直器样式2‘
const initSymbol = [
  'STRENTCHTWO',
  'MORTISE',
  'CCBTSlot',
  'noSymbol',
  'lightSlot',
  'normalSlot',
  'gratingSlot',
  'BP',
  'CCSlot',
  'exSlot',
]
let allSaw = false
let allNoSaw = false
let mixedSaw = false

// 初始化要用到的NC数据
function initSetting(nc_setting) {
  layoutGap = nc_setting.panelSize.layoutGap
  // 门套切割 排版间隙为0
  const isDoorFrame =
    nc_setting.sawSetting.mentaoji_enable &&
    nc_setting.sawSetting.processType === 'doorFrame' &&
    isSawPaiban(store)
  if (isDoorFrame) {
    layoutGap = 0
  }
  plankEdgeOff = nc_setting.panelSize.plankEdgeOff
  // 暂时注释 有问题好恢复
  // cutKnifeRadius = Number(nc_setting.knife.diameter) / 2
  // if (nc_setting.glass_setting) cutKnifeRadius = 0
  cutKnifeRadius = layFunCutKnifeRadius
}

//计算酒隔板形状
function deepCopy(obj) {
  var result = Array.isArray(obj) ? [] : {}
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (typeof obj[key] === 'object') {
        result[key] = deepCopy(obj[key]) //递归复制
      } else {
        result[key] = obj[key]
      }
    }
  }
  return result
}

function calPlanks(pthick, pspacing, width, height, deepOffset, widthOffset) {
  pthick *= 1
  pspacing *= 1
  width *= 1
  height *= 1
  deepOffset *= 1
  widthOffset *= 1
  function isInteger(obj) {
    return obj % 1 === 0
  }
  var cellNum, slotNum
  var slotDepth = width / 2 + deepOffset

  var polygon = [
    { x: 0, y: 0 },
    { x: width, y: 0 },

    { x: width, y: height },

    { x: 0, y: height },
  ]
  var kk = height / (pspacing + pthick)
  kk = Math.ceil(kk)

  for (var i = 1; i <= kk; i++) {
    var mk = i
    var mb = (height - mk * pspacing) / pthick
    var delta = Math.abs(mk - mb)
    if (delta === 1 && mb >= 0) {
      cellNum = mk
      slotNum = cellNum - 1
      var mslot_0 = []
      if (cellNum > 1) {
        //首尾能盖住别的板
        if (mb == slotNum + 2) {
          mslot_0 = [
            { x: width, y: pthick + pspacing - widthOffset },
            { x: width - slotDepth, y: pthick + pspacing - widthOffset },
            {
              x: width - slotDepth,
              y: pthick + pspacing + pthick + widthOffset,
            },
            { x: width, y: pthick + pspacing + pthick + widthOffset },
          ]
        }
        //                    //首尾被别的板夹住
        else if (mb == slotNum) {
          mslot_0 = [
            { x: width, y: pspacing - widthOffset },
            { x: width - slotDepth, y: pspacing - widthOffset },
            { x: width - slotDepth, y: pspacing + pthick + widthOffset },
            { x: width, y: pspacing + pthick + widthOffset },
          ]
        }
        var arr = deepCopy(mslot_0)
        for (var aa = 1; aa < slotNum; aa++) {
          var mslot_aa = []
          for (var idx = 0; idx < mslot_0.length; idx++) {
            var o = mslot_0[idx]
            var str = JSON.stringify(o)
            // var spt = libGG.parseJson(str);
            var spt = JSON.parse(str)
            spt.y += (pspacing + pthick) * aa
            mslot_aa.push(spt)
          }

          arr = arr.ggConcat(mslot_aa)
        }

        for (var i = 0; i < arr.length; i++) {
          var pt = arr[i]
          polygon.splice(2 + i, 0, pt)
        }
      }
    }
  }

  return polygon
}

//排版之前数据预处理
function preProcess(
  pack,
  projectInfo,
  roomInfo,
  isAutoRoll,
  throughTowSideToCut
) {
  if (roomInfo.hasOwnProperty('projectInfo')) {
    projectInfo = roomInfo.projectInfo
    roomInfo['customer_name'] = projectInfo['customer_name']
  }
  var packObj = {}
  if (typeof pack === 'string') {
    packObj = jjFromUnit(pack)
  } else if (typeof pack === 'object') {
    packObj = pack
  }
  var planks = []
  var extras = []
  if (!packObj) {
    return []
  }
  iGatherPlanks(packObj.root, planks, extras)
  // 获取房间名称
  roomName = roomInfo['name']
  roomID = roomInfo['id']
  // 生成板件列表
  var items = []
  for (var i in planks) {
    var p = planks[i]

    var it = TBFZ.classifyPlank(
      p,
      roomName,
      null,
      roomID,
      isAutoRoll,
      throughTowSideToCut,
      xyReverse
    )
    if (it === undefined) {
      continue
    }

    items.push(it)
  }

  // 特殊处理部分
  extras.forEach(function (extra) {
    if (extra.type === 'WLineBottom') {
      var isCut = extra['desc']['BFZ']['isCut']
      var isPolygon = extra['desc']['BFZ']['isPolygon']
      if (!isCut && isPolygon) {
        var gid = extra['gid']
        var loc = extra['loc'] ?? extra['wardrobeName']
        var name = extra['name']
        var plankID = extra['desc']['BFZ']['plankID']
        var partName = extra['partName']
        var size = extra['desc']['BFZ']['size']

        var thick = extra['desc']['BFZ']['thick']
        var matCode = extra['desc']['BFZ']['matCode']
        var texture = extra['desc']['BFZ']['texture']
        var matRotatable = false
        var plankNum = extra['desc']['BFZ']['plankNum']
        var oriPlankNum = extra['desc']['BFZ']['oriPlankNum']
        var edgeThick = extra['desc']['BFZ']['edgeThick']
        var typeName = extra.type

        if (partName.indexOf('踢脚线') != -1) {
          size.height *= 1
          // size.height += 100;//踢脚线少了100，暂未向上追踪原因
          size.height -= edgeThick * 2
          size.width -= edgeThick * 2
        }

        var obj = TBFZ.classifyPlank(
          extra,
          roomName,
          null,
          roomID,
          isAutoRoll,
          throughTowSideToCut,
          xyReverse
        )
        items.push({
          gid: gid,
          loc: loc,
          name: name,
          role: 'Plank',
          plankID: plankID,
          partName: partName,
          rect: Qt.rect(0, 0, size.width, size.height),
          oRect: Qt.rect(
            0,
            0,
            size.width + 2 * edgeThick,
            size.height + 2 * edgeThick
          ),
          realRect: Qt.rect(0, 0, size.width, size.height),
          fullSize: Qt.size(
            size.width + 2 * edgeThick,
            size.height + 2 * edgeThick
          ),
          thick: jjFixed2(thick),
          texture: obj.texture, //genSafeTexture(textureMap, texture),
          matRotatable: matRotatable,
          roomName: roomName,
          plankNum: plankNum,
          matCode: matCode,
          oriPlankNum: oriPlankNum,
          edgeInfo:
            '←' +
            edgeThick +
            '↓' +
            edgeThick +
            '→' +
            edgeThick +
            '↑' +
            edgeThick,
          sholeInfo: '',
          sslotInfo: '',
          holes: [],
          sholes: [],
          slots: [],
          sslots: [],
          typeName: typeName,
          item: extra,
        })
      }
    } else if (
      extra.type === 'SingleDoor' &&
      extra.hasOwnProperty('desc') &&
      extra.desc.hasOwnProperty('BFZ') &&
      extra.desc.BFZ.hasOwnProperty('style')
    ) {
      var isDoorPlank = extra['desc']['BFZ']['style'] === '板式门'
      if (isDoorPlank) {
        var gid = extra['gid']
        var loc = extra['loc'] ?? extra['wardrobeName']
        var name = extra['name']
        var plankID = extra['desc']['BFZ']['plankID']
        var partName = extra['partName']
        var size = extra['desc']['BFZ']['size']
        var thick = extra['desc']['BFZ']['thick']
        var matCode = extra['desc']['BFZ']['matCode']
        var texture = extra['desc']['BFZ']['texture']
        var plankNum = extra['desc']['BFZ']['plankNum']
        var oriPlankNum = extra['desc']['BFZ']['oriPlankNum']
        var edgeThick = extra['desc']['BFZ']['edgeThick']
        var texDir = extra['desc']['BFZ']['texDir']
        var openDir = extra['desc']['BFZ']['openDir']
        var typeName = extra.type
        var matRotatable = extra['matRotatable']

        var obj = TBFZ.classifyPlank(
          extra,
          roomName,
          null,
          roomID,
          isAutoRoll,
          throughTowSideToCut,
          xyReverse
        )

        var textureId = extra['desc']['BFZ']['textureId']
        var nick = ''
        if (textureId) {
          nick = libTexture.getNameByUidAndId(textureId)
        }

        if (size) {
          var objx = {
            gid: gid,
            loc: loc,
            name: name,
            role: 'DoorPlank',
            plankID: plankID,
            partName: partName,
            rect: Qt.rect(0, 0, size.width, size.height),
            oRect: Qt.rect(
              0,
              0,
              size.width + 2 * edgeThick,
              size.height + 2 * edgeThick
            ),
            realRect: Qt.rect(0, 0, size.width, size.height),
            fullSize: Qt.size(
              size.width + 2 * edgeThick,
              size.height + 2 * edgeThick
            ),
            thick: jjFixed2(thick),
            texture: nick,
            matRotatable: matRotatable,
            roomName: roomName,
            plankNum: plankNum,
            matCode: matCode,
            oriPlankNum: oriPlankNum,
            edgeInfo:
              '←' +
              edgeThick +
              '↓' +
              edgeThick +
              '→' +
              edgeThick +
              '↑' +
              edgeThick,
            sholeInfo: '',
            sslotInfo: '',
            holes: obj['holes'],
            sholes: [],
            slots: obj['slots'],
            sslots: [],
            texDir: texDir,
            openDir: openDir,
            typeName: typeName,
            item: extra,
            //                        "path":obj.path,
            //                        "oPath":obj.oPath
          }

          if (
            obj.hasOwnProperty('oPath') &&
            obj.oPath &&
            obj.oPath.length > 0
          ) {
            objx.path = obj.path
            objx.oPath = obj.oPath
          }
          items.push(objx)
        }
      }
    }
  })

  // 附加额外的信息
  items = matchExtraInfo(items, projectInfo, roomInfo)
  return items
}

function genSafeTexture(textureMap, key) {
  if (textureMap && textureMap.hasOwnProperty(key)) {
    return textureMap[key].slice(0, -4)
  }
  return 'NOCOLOR'
}

function iGatherPlanks(pack, planks, extras) {
  var holes = []
  var slots = []
  var handleSlopes = []
  var flag = true
  jjForEachFields(pack, ['children', 'subitems'], function (c) {
    if (c.isInvisible) return
    if (c.type === 'SingleDoor') {
      flag = false
      extras.push(c)
    }
    if (c.type === 'WLineBottom') extras.push(c) //主要处理异形踢脚线

    if (c.type === 'Plank') {
      if (c.hasOwnProperty('parent') && c.parent.type != 'SingleDoor') {
        planks.push(c)
      }
    }
    if (c.type === 'Hole') {
      if (holes.indexOf(c) < 0) {
        holes.push(c)
      }
    }
    if (c.type === 'Slot') {
      if (slots.indexOf(c) < 0) {
        slots.push(c)
      }
    }
  })

  holes.forEach(function (hole) {
    if (hole.referItem !== hole.parent) {
      if (hole.referItem === undefined) {
        xWarnning$('未知的孔', hole.parent.name)
      } else {
        if (hole.referItem.children.indexOf(hole) == -1) {
          hole.referItem.children.push(hole)
        }
      }
    }
  })

  slots.forEach(function (slot) {
    if (slot.referItem !== slot.parent) {
      if (slot.referItem.children.indexOf(slot) == -1) {
        slot.referItem.children.push(slot)
      }
    }
  })

  handleSlopes.forEach(function (slot) {
    if (slot.referItem !== slot.parent) {
      if (slot.referItem.children.indexOf(slot) == -1) {
        slot.referItem.children.push(slot)
      }
    }
  })
}

function matchExtraInfo(planks, projectInfo, roomInfo) {
  var remark = projectInfo['remark']
  var orderNo = projectInfo['order_code']
  var address = projectInfo['buyer_address']
  var customer_name = projectInfo['customer_name']

  var userName = projectInfo['name']
  var createTime = projectInfo['create_time']
  if (projectInfo === undefined || Object.keys(projectInfo).length == 0) {
    address = roomInfo['address']
    customer_name = roomInfo['customer_name']

    orderNo = roomInfo['orderCode']
  }

  //获取房间名称
  roomName = roomInfo['name']

  function fetchPlateGGID(plates, uniqueId) {
    for (var i in plates) {
      var plate = plates[i]
      if (plate['unique_id'] === uniqueId) {
        return plate['ggid']
      }
    }
    return ''
  }
  function fetchPlateGGIDST(plates, uniqueId) {
    for (var i in plates) {
      var plate = plates[i]
      if (plate['unique_id'] === uniqueId) {
        return plate['ggid_short']
      }
    }
    return ''
  }

  function fetchInfo(plates, uniqueId, keys) {
    var retObj = {}
    if (keys && keys.length) {
      for (var i in plates) {
        var plate = plates[i]
        if (plate['unique_id'] === uniqueId) {
          for (var index in keys) {
            var key = keys[index]
            retObj[key] = plate[key]
          }
        }
      }
    }
    return retObj
  }

  function fetchPlatesMap(projectInfo, ri) {
    var map = {}

    var id = ri['id']
    var name = ri['name']

    var rooms = projectInfo['room']

    for (var j in rooms) {
      var room = rooms[j]
      if (room['id'] === id) {
        if (!room['plate']) {
          room['plate'] = []
        }
        if (!room['door']) {
          room['door'] = []
        }
        map[name] = room['plate'].ggConcat(room['door'])
        break
      }
    }

    return map
  }
  var platesMap = fetchPlatesMap(projectInfo, roomInfo)

  for (var i in planks) {
    var part = planks[i]
    var item = part['item']
    if (item) {
      var keys = ['ggid', 'ggid_short', 'color']
      var values = fetchInfo(platesMap[roomName], item['uniqueId'], keys)
      var ggid = values['ggid']
      var ggid_short = values['ggid_short']
      var color = values['color']
      part['ggid'] = ggid
      part['ggid_short'] = ggid_short
      part['remark'] = remark
      part['address'] = address

      part['customer_name'] = customer_name

      part['orderNo'] = orderNo
      part['userName'] = userName
      part['createTime'] = createTime
      part['texDir'] = item['texDir']
      if (!part['texture'] || part['texture'] === 'NOCOLOR') {
        part['texture'] = color
      }
    }
  }

  return planks
}

//排版之后数据处理
// key为排版接口返回的板件分类键名
// retmap为排版接口返回的板件分类键值
// oriData为预处理之后的数据
// colorRes颜色列表
// 后面的参数暂时不用管
async function partialProcess(
  isPerLoad,
  key,
  retMap,
  oriData,
  colorRes,
  config,
  isMeticulous,
  bigPlankWidth,
  bigPlankHeight,
  mStockNum
) {
  var result = {}
  var parts = retMap['data']

  var thick = String(key).split(':')[2]
  var texture = String(key).split(':')[0]
  var matCode = String(key).split(':')[1]

  var dataLst = []
  //处理正常排版板件
  const sawToLayout =
    config.sawSetting.mentaoji_enable &&
    config.sawSetting.sawToLayout &&
    config.sawSetting.processType === 'weldingPlank' &&
    isSawPaiban(store)
  const sawCutOnlyWeld =
    config.sawSetting.sawCutOnlyWeld &&
    config.sawSetting.mentaoji_enable &&
    config.sawSetting.sawToLayout &&
    config.sawSetting.processType === 'weldingPlank'
  for (var i in parts) {
    var tmpPart = parts[i]
    var tmpData = {}
    for (var ind in tmpPart) {
      if (isPerLoad) {
        await new Promise((resolve) => setTimeout(resolve))
      }
      var dstPart = tmpPart[ind]
      await comparePart(
        thick,
        texture,
        matCode,
        dstPart,
        oriData,
        tmpData,
        isMeticulous,
        bigPlankWidth,
        bigPlankHeight,
        mStockNum,
        colorRes,
        key,
        config,
        sawToLayout,
        sawCutOnlyWeld
      )
    }
    dataLst.push(tmpData)
  }
  // 生成对纹组的字母标识
  dataLst.forEach((v) =>
    Object.values(v).forEach((plank) => genLabelTextureGroups(plank.parts))
  )
  result['data'] = dataLst
  result['rollCount'] = retMap['rollCount']
  result['used_rate'] = retMap['used_rate']
  result['plank_remarks'] = retMap['plank_remarks']

  //处理挖洞
  if (retMap.hasOwnProperty('holes')) {
    var holeinfo = {}
    var holes = retMap['holes']

    for (var k in holes) {
      var holePart = holes[k]
      var hole = holePart['holes']
      var stockNum = holePart['stockNum']
      var stockKey = texture + ':' + matCode + ':' + thick + ':' + stockNum

      if (!holeinfo.hasOwnProperty(stockKey)) {
        holeinfo[stockKey] = {
          thick: thick,
          matCode: matCode,
          texture: texture,
          stockNum: stockNum,
          stockKey: stockKey,
          parts: [],
        }
      }

      hole.forEach(function (part) {
        var x = part['x']
        var y = part['y']
        var width = part['width']
        var height = part['height']

        // 调整排版原点
        if (startPosition === '左上角') {
        } else if (startPosition === '左下角') {
          part['y'] = plankHeight - (y + height)
        } else if (startPosition === '右下角') {
          part['x'] = plankWidth - (x + width)
          part['y'] = plankHeight - (y + height)
        } else if (startPosition === '右上角') {
          part['x'] = plankWidth - (x + width)
        }
      })

      holeinfo[stockKey]['holes'] = hole
    }
    result['holeInfo'] = holeinfo
  }
  return result
}

export async function afterProcess(
  oriResult,
  oriData,
  config,
  isPerLoad,
  colorRes,
  layoutConfig = {}
) {
  // 初始化一些数据
  initSetting(config)
  ncConfig = config
  // layoutGap = config.panelSize.layoutGap
  // plankEdgeOff = config.panelSize.plankEdgeOff
  var container = {}
  if (store.state.ncSetting.uniqueBarCode) {
    noRepeatPlankNum(oriResult)
  }

  // 不同材质下料刀会调用两次排版接口，这样就有可能将我之前的mixedSaw给覆盖掉，所以在排版后，在判断一下
  allSaw = oriData.every((part) => part.isUseSaw)
  allNoSaw = oriData.every((part) => !part.isUseSaw)
  mixedSaw = !allSaw && !allNoSaw
  for (var key in oriResult) {
    container[key] = {}
    var retMap = oriResult[key]
    // 多材质下料刀可能有不同的刀径
    const diameter = +getPlateKnifeDiameter(key, config)
    const sawKnives = config.sawSetting?.mentaoji_saws
    if (sawKnives) {
      const hSawKnives = sawKnives
        .filter((item) => item.saw_direction == 'H')
        .map((item) => item.saw_width)
      sawDiameter = Number(Math.min(...hSawKnives))
    } else {
      // 预排版里面的 横切刀直径
      sawDiameter = Number(config.sawSetting?.horizontalWidth)
    }
    // 只有全部异形才用下料刀
    // if (
    //   oriData.every((item) => {
    //     return !item.isUseSaw
    //   })
    // ) {
    //   cutKnifeRadius = diameter / 2
    // } else {
    //   cutKnifeRadius = sawDiameter / 2
    // }
    container[key] = await partialProcess(
      isPerLoad,
      key,
      retMap,
      oriData,
      colorRes,
      config,
      false,
      layoutConfig.plankWidth,
      layoutConfig.plankHeight
    )
    // 将孔槽按照比例进行分配
    if (
      store.state.isResetPaibanAllocation &&
      !store.state.paibanInfo?.isSpecialShape
    ) {
      container[key].data.forEach((it) => {
        Object.values(it).forEach((plank) => {
          allocationHoleSlot(plank)
        })
      })
    }
  }
  return container
}

//处理单个板件
function comparePart(
  thick,
  texture,
  matCode,
  dstPart,
  originData,
  container,
  isMeticulous,
  bigPlankWidth,
  bigPlankHeight,
  mStockNum,
  colorRes,
  key,
  config,
  sawToLayout, // 锯切排板,
  sawCutOnlyWeld // 锯切直排焊接板
) {
  const keyParts = String(key).split(':')
  const brandName = keyParts[3] || ''
  const supplierName = keyParts[4] || ''
  const diameter = +getPlateKnifeDiameter(key, config)
  const { specified_board_secondary_cutting, secondary_cutting_board_list } =
    config.longPlankCuttingSetting
  const currentLine = store.state.proLineList.find(
    (line) => line.id === store.state.ncSetting.process_setting_id
  )
  for (var j in originData) {
    var srcPart = originData[j]
    srcPart = cloneDeep(srcPart)
    // 添加对应颜色
    srcPart.colorRes = {}
    if (JSON.stringify(colorRes) == '{}') {
      srcPart.colorRes = null
    } else {
      for (let item of labelSources) {
        if (colorRes[item]) {
          srcPart.colorRes[item] =
            colorRes[item][(srcPart[item] ?? '')?.toString()]
        } else {
          srcPart.colorRes[item] = 'rgb(255, 255, 255)'
        }
      }
    }
    /**
     * 新版采用唯一 ID 的方式验证唯一板件
     */
    const isPass = dstPart.id === srcPart.partUniqueId
    if (isPass) {
      if (!sawToLayout) dstPart['rect'] = srcPart['rect']
      var stockNum = dstPart['stockNum']
      const allColors =
        store.state.materialListStore.selectedMixPaibanPlans.find((plan) =>
          matchMixPaibanPlan(plan, srcPart)
        )?.allColors ?? []
      if (mStockNum) {
        stockNum = mStockNum
      }

      var surplusInfo = dstPart['surplusInfo']
      var otherPlate = dstPart['otherPlate']
      if (otherPlate && Object.keys(otherPlate).length > 0) {
        surplusInfo = otherPlate
        surplusInfo.isNotSurplus = true
        const oriInfo = surplusInfo.ori_info ?? surplusInfo.oriInfo
        const height = oriInfo
          ? oriInfo.height ?? oriInfo.long
          : surplusInfo['height']
        const width = oriInfo ? oriInfo.width : surplusInfo['width']
        surplusInfo['height'] = height
        surplusInfo['width'] = width
        // 先直接从算法返回的修边信息中直接取值
        otherPlate.trim_edge = Array.isArray(otherPlate?.margin)
          ? plankEdgeTransform(otherPlate.margin)
          : void 0
        if (store.state.specialPlankParams.length) {
          store.state.specialPlankParams.forEach((item) => {
            if (
              item.matCode == srcPart.matCode &&
              (allColors.includes(item.color) ||
                item.color == srcPart.texture) &&
              item.thick == srcPart.thick &&
              item.height == height &&
              item.width == width
            ) {
              otherPlate.trim_edge = item.trim_edge
              otherPlate.id = item.id
            }
          })
        }
        otherPlate.trim_edge = fourTrimEdge(
          otherPlate.trim_edge,
          store.state.ncSetting
        )
      }
      if (surplusInfo) {
        // var surplusId = surplusInfo['id'] // 这个好像没啥用
        // 处理xy轴互换的问题
        if (Object.keys(surplusInfo).length && !surplusInfo.isNotSurplus) {
          if (surplusInfo.path) {
            const pathLength = surplusInfo.path.length
            surplusInfo.shape =
              pathLength < 6
                ? 'rect'
                : pathLength < 8
                ? 'lshape'
                : 'specialShape'
          }
          surplusInfo.surplus_trim_edge = fourTrimEdge(
            surplusInfo.surplus_trim_edge,
            store.state.ncSetting
          )
        }
      }
      var stockKey = texture + ':' + matCode + ':' + thick + ':' + stockNum
      var curKey = texture + ':' + matCode + ':' + thick
      //处理大板的宽高
      plankWidth =
        store.state.selectStandardPlank &&
        Object.keys(store.state.selectStandardPlank).length
          ? store.state.selectStandardPlank.plankWidth
          : srcPart['plankWidth']
      plankHeight =
        store.state.selectStandardPlank &&
        Object.keys(store.state.selectStandardPlank).length
          ? store.state.selectStandardPlank.plankHeight
          : srcPart['plankHeight']
      if (surplusInfo && Object.keys(surplusInfo).length > 0) {
        const oriInfo = surplusInfo.ori_info ?? surplusInfo.oriInfo

        if (surplusInfo['width'] != undefined) {
          bigPlankWidth = oriInfo ? oriInfo.width : surplusInfo['width']
          bigPlankHeight = oriInfo
            ? oriInfo.height ?? oriInfo.long
            : surplusInfo['height']
        } else {
          var surplusWidth = 0
          var surplusHeight = 0
          if (surplusInfo.hasOwnProperty('plankWidth')) {
            surplusWidth = surplusInfo['plankWidth']
            surplusHeight = surplusInfo['plankHeight']
          } else {
            surplusWidth = surplusInfo['x5']
            surplusHeight = surplusInfo['y3']
          }
          surplusInfo['width'] = surplusWidth
          surplusInfo['height'] = surplusHeight
          bigPlankWidth = surplusWidth
          bigPlankHeight = surplusHeight
        }

        if (surplusInfo.path) {
          surplusInfo.path = dealPathToBasePoint(flipPath(surplusInfo.path))
          const pathLength = surplusInfo.path.length
          surplusInfo.shape =
            pathLength < 6 ? 'rect' : pathLength < 8 ? 'lshape' : 'specialShape'
        }
      }
      var isSurplus = false
      var surplusMargin = ncConfig.panelSize.surplusMargin
      if (surplusInfo && surplusInfo.hasOwnProperty('isSurplus')) {
        isSurplus = surplusInfo['isSurplus']
      }

      var rotatePart = {}

      dstPart['_flipXCount'] = srcPart['_flipXCount'] ?? 0
      dstPart['_flipYCount'] = srcPart['_flipYCount'] ?? 0
      dstPart['_rotateAngle'] = srcPart['_rotateAngle'] ?? 0
      dstPart['_transformLog'] = srcPart['_transformLog']
        ? JSON.parse(JSON.stringify(srcPart['_transformLog']))
        : []

      var isRotate = dstPart['rotate']
      if (isRotate) {
        const rotateSourcePart = cloneDeep(srcPart)
        switch (isRotate) {
          case 180:
            rotatePart = rotate180Part(rotateSourcePart)
            break
          case 270:
            rotatePart = rotate(rotate180Part(rotateSourcePart))
            break
          default:
            rotatePart = rotate(rotateSourcePart)
            break
        }
        var rotateAngle = isRotate == 1 ? 90 : isRotate
        recordTransform(dstPart, 'rotate', rotateAngle, 'layoutResult-rotate')
      }

      dstPart['expandRect'] = isRotate
        ? rotatePart['expandRect']
        : srcPart['expandRect']

      if (
        !sawToLayout ||
        (sawToLayout && sawCutOnlyWeld && !srcPart.isWeldingPlank)
      ) {
        dstPart['rect'] = isRotate
          ? rotatePart['rect']
          : srcPart['rect']
          ? srcPart['rect']
          : ''
      }
      dstPart['oRect'] = isRotate
        ? rotatePart['oRect']
        : srcPart['oRect']
        ? srcPart['oRect']
        : ''

      dstPart['rect']['width'] = toDecimal(
        dstPart['rect']['width'],
        store.state.ncSetting.decimal
      )
      dstPart['rect']['height'] = toDecimal(
        dstPart['rect']['height'],
        store.state.ncSetting.decimal
      )
      dstPart['oRect']['width'] = toDecimal(
        dstPart['oRect']['width'],
        store.state.ncSetting.decimal
      )
      dstPart['oRect']['height'] = toDecimal(
        dstPart['oRect']['height'],
        store.state.ncSetting.decimal
      )
      dstPart['layout_time'] = srcPart['layout_time']
      var startX = dstPart['startX']
      var startY = dstPart['startY']
      var rectWidth = dstPart['rect']['width']
      var rectHeight = dstPart['rect']['height']

      // let plankEdge =
      //   otherPlate && Object.keys(otherPlate).length
      //     ? otherPlate.trim_edge
      //     : store.state.selectStandardPlank.plankEdgeOff
      // 这里的修边需要同步改变
      let plankEdge =
        otherPlate && Object.keys(otherPlate).length
          ? otherPlate.trim_edge
          : surplusInfo &&
            Object.keys(surplusInfo).length &&
            !surplusInfo?.isNotSurplus
          ? surplusInfo.surplus_trim_edge
          : store.state.selectStandardPlank.plankEdgeOff
      let plankEdgeFront
      let plankEdgeLeft
      if (plankEdge.toString().includes(',')) {
        const edgeArr = plankEdge.toString().split(',')
        plankEdgeFront = Number(edgeArr[0])
        plankEdgeLeft = Number(edgeArr[2])
      } else {
        plankEdgeFront = Number(plankEdge)
        plankEdgeLeft = Number(plankEdge)
      }
      var tmpValue = layoutGap - (plankEdgeFront - cutKnifeRadius) * 2
      var tmpValue2 = 0
      var tmpValueLeft = layoutGap - (plankEdgeLeft - cutKnifeRadius) * 2
      var tmpValue2Left = 0

      if (!isMeticulous) {
        if (isSurplus && !surplusMargin) {
          tmpValue = -plankEdgeFront
          tmpValue2 = -plankEdgeFront
          tmpValueLeft = -plankEdgeLeft
          tmpValue2Left = -plankEdgeLeft
        }
        tmpValue = srcPart['isUseSaw'] ? -(sawDiameter / 2) : -(diameter / 2)
        tmpValue2 = srcPart['isUseSaw'] ? -(sawDiameter / 2) : -(diameter / 2)
        tmpValueLeft = srcPart['isUseSaw']
          ? -(sawDiameter / 2)
          : -(diameter / 2)
        tmpValue2Left = srcPart['isUseSaw']
          ? -(sawDiameter / 2)
          : -(diameter / 2)
        // if(isYunLayout) {sawDiameter
        // } else if (!isTestLayoutPlank) {
        //     tmpValue = layoutGap;
        // }
      }

      if (!bigPlankWidth || !bigPlankHeight) {
        bigPlankWidth = plankWidth
        bigPlankHeight = plankHeight
      }

      // dstPart["startY"] = keepDecimalNumBySetting(ncConfig, dstPart["startY"])
      // dstPart["startX"] = keepDecimalNumBySetting(ncConfig, dstPart["startX"])

      // 柜门历史进入，从存入的板件中取字段
      let guimenKeys = store.state.guimenDataKeys
      if (
        sessionStorage.getItem('thinkerx_material') &&
        sessionStorage.getItem('isHistory')
      ) {
        guimenKeys = Object.keys(srcPart)
      }
      // 算法返回的字段都不要处理
      const guimenIgnoreKeys = [
        'oRect',
        'rect',
        'startX',
        'startY',
        'priority',
        'cutOrigin',
        'index',
        'otherPlate',
        'surplusInfo',
        'stockNum',
        'rotate',
      ]
      for (let ii = 0; ii < guimenKeys.length; ++ii) {
        let guimenKey = guimenKeys[ii]
        if (!guimenIgnoreKeys.includes(guimenKey)) {
          dstPart[guimenKey] = srcPart[guimenKey]
        }
      }
      // 三方带过来的自定义数据
      const thinkerxMaterialKeys = store.state.thinkerxMaterialKeys
      thinkerxMaterialKeys.forEach((v) => {
        dstPart[v.value] = srcPart[v.value]
      })

      if (srcPart['manualTrunOver'] != undefined) {
        dstPart['manualTrunOver'] = srcPart['manualTrunOver']
      }
      if (srcPart['changedTexDir'] != undefined) {
        dstPart['changedTexDir'] = srcPart['changedTexDir']
      }
      if (srcPart['preRect'] != undefined) {
        dstPart['preRect'] = srcPart['preRect']
      }

      if (srcPart['holeError']) {
        dstPart['holeError'] = srcPart['holeError']
      }
      if (srcPart['srcTexDir']) {
        dstPart['srcTexDir'] = srcPart['srcTexDir']
      }
      dstPart['oriPartUniqueId'] =
        srcPart['oriPartUniqueId'] ?? srcPart['partUniqueId']
      dstPart['texDir'] = srcPart['texDir']
      dstPart['openDir'] = srcPart['openDir']
      dstPart['gid'] = srcPart['gid']
      dstPart['loc'] = srcPart['loc'] ?? srcPart['wardrobeName']
      // 第三方 get_layout_data 带入的字段，下载 NC 需原样回传
      dstPart['wardrobeName'] = srcPart['wardrobeName']
      dstPart['userName'] = srcPart['userName']
      dstPart['createTime'] = srcPart['createTime']
      dstPart['render_url'] = srcPart['render_url']
      dstPart['name'] = srcPart['name']
      dstPart['plankID'] = srcPart['plankID']
      dstPart['partName'] = srcPart['partName']
      dstPart['item'] = srcPart['item']
      dstPart['loc_size'] = srcPart['loc_size']
      dstPart['curveHoles'] = isRotate
        ? rotatePart['curveHoles']
        : srcPart['curveHoles']
      dstPart['millInfo'] = isRotate
        ? rotatePart['millInfo']
        : srcPart['millInfo']
      dstPart['oriCurveHoles'] = isRotate
        ? rotatePart['oriCurveHoles']
        : srcPart['oriCurveHoles']
      dstPart['plankType'] = srcPart['plankType']
      dstPart['path'] = isRotate ? rotatePart['path'] : srcPart['path']
      dstPart['srcPath'] = isRotate ? rotatePart['srcPath'] : srcPart['srcPath']
      dstPart['unionPath'] = isRotate
        ? rotatePart['unionPath']
        : srcPart['unionPath']
      dstPart['oPath'] = isRotate ? rotatePart['oPath'] : srcPart['oPath']
      dstPart['realCurve'] = isRotate
        ? rotatePart['realCurve']
        : srcPart['realCurve']
      dstPart['pathEdge'] = srcPart['pathEdge']
      dstPart['plankKnife'] = srcPart['plankKnife']
      dstPart['realCurveEx'] = isRotate
        ? rotatePart['realCurveEx']
        : srcPart['realCurveEx']
      dstPart['cutCurve'] = isRotate
        ? rotatePart['cutCurve']
        : srcPart['cutCurve']
      dstPart['cutCurveEx'] = isRotate
        ? rotatePart['cutCurveEx']
        : srcPart['cutCurveEx']
      dstPart['thick'] = srcPart['thick']
      dstPart['texture'] = srcPart['texture']
      dstPart['oriTexture'] = srcPart['oriTexture']
      dstPart['renderUrl'] = srcPart['renderUrl']
      dstPart['from'] = srcPart['from']
      dstPart['matRotatable'] = srcPart['matRotatable']
      dstPart['roomName'] = srcPart['roomName']
      dstPart['roomID'] = srcPart['roomID']
      dstPart['designer'] = srcPart['designer']
      dstPart['holes'] = isRotate ? rotatePart['holes'] : srcPart['holes']
      dstPart['hingeInfo'] = srcPart['hingeInfo'] ? srcPart['hingeInfo'] : []
      dstPart['slots'] = isRotate ? rotatePart['slots'] : srcPart['slots']
      dstPart['handleSlopes'] = isRotate
        ? rotatePart['handleSlopes']
        : srcPart['handleSlopes']
      dstPart['sholes'] = isRotate ? rotatePart['sholes'] : srcPart['sholes']
      dstPart['lineSlots'] = isRotate
        ? rotatePart['lineSlots'] ?? []
        : srcPart['lineSlots'] ?? []
      dstPart['sslots'] = isRotate ? rotatePart['sslots'] : srcPart['sslots']
      dstPart['plankNum'] = srcPart['plankNum']
      // 原始条码：打包专用条码(板件条码唯一)追加序号时需要以它为前缀
      // 若此处不透传，排版结果里的板件会丢失该字段，复制大板时拼接出 undefined1 这类条码
      // 用 hasOwnProperty 守卫，避免在 dstPart 上注入值为 undefined 的 own property
      if (Object.prototype.hasOwnProperty.call(srcPart, '_plankNum')) {
        dstPart['_plankNum'] = srcPart['_plankNum']
      }
      dstPart['matCode'] = srcPart['matCode']
      dstPart['oriPlankNum'] = srcPart['oriPlankNum']
      dstPart['hsInfo'] = srcPart['hsInfo'] ? srcPart['hsInfo'] : ''
      dstPart['handle'] = srcPart['handle'] ? srcPart['handle'] : null
      dstPart['partsChildren'] = srcPart['partsChildren']
        ? srcPart['partsChildren']
        : null
      dstPart['remarks'] = srcPart['remarks']
      // 门窗过备注
      dstPart['remark1'] = srcPart['remark1'] ? srcPart['remark1'] : ''
      dstPart['remark2'] = srcPart['remark2'] ? srcPart['remark2'] : ''
      dstPart['remark3'] = srcPart['remark3'] ? srcPart['remark3'] : ''
      dstPart['installNum'] = srcPart['installNum'] ? srcPart['installNum'] : ''
      dstPart['edge_length_info'] = srcPart['edge_length_info']
      dstPart['edge_length_info2'] = srcPart['edge_length_info2']
      dstPart['hardware'] = srcPart['hardware']
      dstPart['edge_texture_map'] = isRotate
        ? rotatePart['edge_texture_map']
        : srcPart['edge_texture_map']
      dstPart['edgeArrowMap'] = isRotate
        ? rotatePart['edgeArrowMap']
        : srcPart['edgeArrowMap']
      //正面没有孔槽表示  用于标签中不生成条码
      dstPart['hasOriPlankNum'] = hasRevPlankHoleOrSlot(srcPart, 1)
      //判断是否有反面条码
      if (hasRevPlankHoleOrSlot(srcPart, -1)) {
        dstPart['oriPlankNumF'] = srcPart['plankNum'] + 'K'
        dstPart['simplePlankNumF'] = srcPart['simplePlankNum'] + 'K'
      }
      dstPart['plankNumType2'] = srcPart['plankNumType2']
      dstPart['realRect'] = isRotate
        ? rotatePart['realRect']
        : srcPart['realRect']

      dstPart['fullSize'] = srcPart['fullSize']
      dstPart['edgeInfo'] = isRotate
        ? rotatePart['edgeInfo']
        : srcPart['edgeInfo']
      dstPart['sholeInfo'] = isRotate
        ? rotatePart['sholeInfo']
        : srcPart['sholeInfo']
      dstPart['sslotInfo'] = isRotate
        ? rotatePart['sslotInfo']
        : srcPart['sslotInfo']
      dstPart['ggid'] = srcPart['ggid']
      dstPart['ggid_short'] = srcPart['ggid_short']
      dstPart['remark'] = srcPart['remark']
      dstPart['remarks'] = srcPart['remarks']
      // dstPart['customer_name'] =
      //   srcPart['customer'] ?? srcPart['customer_name']
      // 这个地方是为了老板良才这样处理的
      dstPart['customer_name'] = srcPart['customer_name']
      dstPart['address'] = srcPart['address']
      dstPart['orderNo'] = srcPart['orderNo']
      dstPart['orderId'] = srcPart['orderId']
      dstPart['needRoll'] = srcPart['needRoll']
      dstPart['oriHoles'] = srcPart.hasOwnProperty('oriHoles')
        ? srcPart['oriHoles']
        : srcPart['holes']
      dstPart['oriSlots'] = srcPart.hasOwnProperty('oriSlots')
        ? srcPart['oriSlots']
        : srcPart['slots']
      dstPart['oriSholes'] = srcPart.hasOwnProperty('oriSholes')
        ? srcPart['oriSholes']
        : srcPart['sholes']
      dstPart['oriSslots'] = srcPart.hasOwnProperty('oriSslots')
        ? srcPart['oriSslots']
        : srcPart['sslots']
      dstPart['stockKey'] = stockKey
      dstPart['labelId'] = srcPart['labelId']
      dstPart['plankWidth'] = bigPlankWidth
      dstPart['plankHeight'] = bigPlankHeight
      dstPart['drawerStyle'] = srcPart['drawerStyle']
      dstPart['depth'] = srcPart['depth']
      dstPart['is_high_gloss_plank'] = srcPart['is_high_gloss_plank']
      dstPart['high_gloss_side'] = srcPart['high_gloss_side']
      dstPart['hing_hole_info'] = srcPart['hing_hole_info']
      dstPart['model_front_edge'] = isRotate
        ? rotatePart['model_front_edge']
        : srcPart['model_front_edge']
      dstPart['smoothEdge'] = isRotate
        ? rotatePart['smoothEdge']
        : srcPart['smoothEdge']
      dstPart['lightEdgeInfo'] = isRotate
        ? rotatePart['lightEdgeInfo']
        : srcPart['lightEdgeInfo']
      dstPart['edgePreMillingInfo'] = isRotate
        ? rotatePart['edgePreMillingInfo']
        : srcPart['edgePreMillingInfo']
      //简易标签条码显示
      dstPart['simplePlankNum'] = srcPart['simplePlankNum']
      dstPart['quantity'] = 1
      dstPart['specWidth'] = +(srcPart['specWidth'] ?? 0)
      dstPart['specHeight'] = +(srcPart['specHeight'] ?? 0)
      dstPart['checklistID'] = srcPart['checklistID']
      dstPart['extraParts'] = srcPart['extraParts']
      dstPart['isFrontPlank'] = srcPart['isFrontPlank']
      dstPart['doorOpenSide'] = isRotate
        ? rotatePart['doorOpenSide']
        : srcPart['doorOpenSide']
      dstPart['specialFlag'] = srcPart['specialFlag']
      dstPart['finishedArea'] = srcPart['finishedArea']
      dstPart['partNameWithoutRoomCabinet'] =
        srcPart['partNameWithoutRoomCabinet']
      if (srcPart['manualAdd']) {
        dstPart['manualAdd'] = srcPart['manualAdd']
      }
      if (srcPart['isManual']) {
        dstPart['isManual'] = srcPart['isManual']
      }
      if (srcPart['type']) {
        dstPart['type'] = srcPart['type']
      }
      if (srcPart['specialType']) {
        dstPart['specialType'] = srcPart['specialType']
      }
      if (srcPart['surplusIndex']) {
        dstPart['surplusIndex'] = srcPart['surplusIndex']
      }
      if (srcPart['from_address']) {
        dstPart['from_address'] = srcPart['from_address']
      }
      if (srcPart['from_order_num']) {
        dstPart['from_order_num'] = srcPart['from_order_num']
      }
      if (srcPart['surplusPath']) {
        dstPart['surplusPath'] = srcPart['surplusPath']
      }
      if (srcPart['isSave']) {
        dstPart['isSave'] = srcPart['isSave']
      }
      if (srcPart['surplus_id']) {
        dstPart['surplus_id'] = srcPart['surplus_id']
      }
      dstPart['partUniqueId'] = srcPart['partUniqueId']
      dstPart['outItemPanelId'] = srcPart['outItemPanelId']
      dstPart['plank_remarks'] = srcPart['plank_remarks']
      dstPart['order_remark'] = srcPart['order_remark']
      dstPart['process_label'] = srcPart['process_label']
      dstPart['startY'] = Number(
        Number(dstPart['startY']).toFixed(store.state.ncSetting.decimal)
      )
      // 给板件上增加连接方式字段
      dstPart['connection_types'] = srcPart['connection_types']
      dstPart['parentType'] = srcPart['parentType']
      dstPart['_isBujian'] = srcPart['_isBujian']
      dstPart['_bujianAddress'] = srcPart['_bujianAddress']
      dstPart['_bujianOid'] = srcPart['_bujianOid']
      dstPart['_bujianOrderNo'] = srcPart['_bujianOrderNo']
      dstPart['_bujianPlankNum'] = srcPart['_bujianPlankNum']
      dstPart['_bujianCustomerName'] = srcPart['_bujianCustomerName']
      dstPart['_isAwaitStorePlank'] = srcPart['_isAwaitStorePlank']
      dstPart['_awaitStoreId'] = srcPart['_awaitStoreId']
      dstPart['_bujianStoreId'] = srcPart['_bujianStoreId']
      dstPart['_isNewTableBujian'] = srcPart['_isNewTableBujian']
      // 跨材质标记：srcPart 来自 preLayoutData 时不含这些字段（无操作），
      // 用 hasOwnProperty 守卫，避免在 dstPart 上注入值为 undefined 的 own property
      if (Object.prototype.hasOwnProperty.call(srcPart, '_isCrossMaterial')) {
        dstPart['_isCrossMaterial'] = srcPart['_isCrossMaterial']
      }
      if (Object.prototype.hasOwnProperty.call(srcPart, '_oriTexture')) {
        dstPart['_oriTexture'] = srcPart['_oriTexture']
      }
      if (Object.prototype.hasOwnProperty.call(srcPart, '_oriMatCode')) {
        dstPart['_oriMatCode'] = srcPart['_oriMatCode']
      }
      dstPart['colorRes'] = srcPart['colorRes']
      dstPart['isUseSaw'] = srcPart['isUseSaw']
      dstPart['isRotateFrontEdge'] = srcPart['isRotateFrontEdge']
      dstPart['process_in_engraving_to_curve'] =
        srcPart['process_in_engraving_to_curve']
      dstPart['engraving_cut_curve'] = srcPart['engraving_cut_curve']
      dstPart['engraving_cut_curve_to_turn'] =
        srcPart['engraving_cut_curve_to_turn']
      dstPart['isWeldingPlank'] = srcPart['isWeldingPlank']
      // 骨骼门
      dstPart['frame_door'] = srcPart['frame_door']
      dstPart['frame_door_children'] = isRotate
        ? rotatePart['frame_door_children']
        : srcPart['frame_door_children']
      dstPart['textureGrainInfo'] = srcPart['textureGrainInfo']

      // 品牌板件相关信息
      dstPart['colorId'] = srcPart['colorId']
      dstPart['brandName'] = srcPart['brandName']
      dstPart['supplierName'] = srcPart['supplierName']

      // 余料自定义修边问题处理
      // 如果已经确定修边的话，新的逻辑走这里
      // 长板加工 指定板件名称二次切割开关开启后，小板名称包含指定的板件名称 给后端添加字段标识
      const partName = srcPart['partName'] || srcPart['name'] || ''
      if (
        specified_board_secondary_cutting &&
        secondary_cutting_board_list.some((item) => partName.includes(item))
      ) {
        dstPart['specified_board_secondary_cutting'] = true
      }
      if (!store.state.ncSetting.isPreLayout) {
        // 预排版不走这个逻辑
        if (isOnlyProcessSlotAndHole(currentLine, srcPart.matCode)) {
          dstPart['isDesMaterialNoCut'] = true
        }
      }

      // 易达铰链孔二维码打孔
      if (srcPart['remark_names']) {
        const remarkNamesMap = new Map(
          Object.keys(srcPart['remark_names']).map((k) => [
            srcPart['remark_names'][k],
            k,
          ])
        )
        if (remarkNamesMap.has('易达设备对接码')) {
          let key = remarkNamesMap.get('易达设备对接码')
          dstPart['hingeEquipment'] = srcPart[key] || ''
        }
      }
      var slots = dstPart['slots']

      const isNeedRotate =
        dstPart['rotate'] && [90, 270].includes(dstPart['rotate'])
      // 获取原始计算的槽扩板值，并跟随旋转进行处理，在将板件的位置进行偏移
      const finalExtendDisMap = getRotateObject(
        srcPart['finalExtendDisMap'],
        dstPart['rotate'] == 1 ? 90 : dstPart['rotate']
      )
      dstPart['finalExtendDisMap'] = finalExtendDisMap
      // [锯切异形debug] 捕获算法返回的排版框（左上角原点，未加 fedm、未换算原点前的原值）
      const __dbgSaw =
        dstPart['isUseSaw'] && dstPart['path'] && dstPart['path'][0]
          ? {
              LX: dstPart['startX'],
              LY: dstPart['startY'],
              layoutW: dstPart['rect']['width'],
              layoutH: dstPart['rect']['height'],
            }
          : null
      // [锯切异形] 暂存排版框（算法原值）+ fedm，用于 paibanDataToView 修正 startX/startY 为绿框左上角
      if (__dbgSaw) {
        dstPart.__sawLayout = { ...__dbgSaw, fedm: finalExtendDisMap }
        // [锯切异形] 绿路径相对 srcPath 的扩张量，随 fedm 同角度旋转到最终坐标帧
        if (srcPart.__sawExtension) {
          dstPart.__sawExtension = getRotateObject(
            srcPart.__sawExtension,
            dstPart['rotate'] == 1 ? 90 : dstPart['rotate']
          )
        }
      }
      const ncSetting = store.state.ncSetting
      const stationWidth = ncSetting.counter_width
      const counter_limit_able = ncSetting.counter_limit_able
      if (counter_limit_able && bigPlankWidth > stationWidth) {
        const startStation = ncSetting.startPosition
        if (startStation.includes('右')) {
          dstPart['startX'] = dstPart['startX'] + (bigPlankWidth - stationWidth)
        }
        if (surplusInfo && !surplusInfo.isNotSurplus && surplusInfo.path) {
          if (surplusInfo.oriInfo) {
            surplusInfo.path = surplusInfo.oriInfo.path
            surplusInfo.width = surplusInfo.oriInfo.width
            surplusInfo.height =
              surplusInfo.oriInfo.height ?? surplusInfo.oriInfo.long
            surplusInfo.long = surplusInfo.oriInfo.long
          }
          const realHeight = surplusInfo.height
          dstPart['startY'] = dstPart['startY'] + (bigPlankHeight - realHeight)
        }
      }

      if (finalExtendDisMap) {
        const expandVals = Object.values(finalExtendDisMap)
        dstPart['isExpanded'] = expandVals.some((val) => Boolean(val))
        for (const key in finalExtendDisMap) {
          const extendDis = Number(finalExtendDisMap[key])
          switch (key) {
            case 'left':
              dstPart['startX'] += extendDis
              break
            case 'bottom':
              dstPart['startY'] += extendDis
              break
          }
        }
      }
      changePositionCutOrigin(
        dstPart,
        tmpValue,
        tmpValue2,
        tmpValueLeft,
        tmpValue2Left,
        bigPlankWidth,
        bigPlankHeight,
        sawDiameter,
        diameter,
        sawToLayout,
        sawCutOnlyWeld
      )
      // 这里比较杂乱，开启焊接板第九点要判断小板是否是焊接板，不开地酒店则不需要
      if (
        finalExtendDisMap &&
        ((sawToLayout && !sawCutOnlyWeld) ||
          (sawToLayout && sawCutOnlyWeld && dstPart.isWeldingPlank))
      ) {
        const d = dstPart['isUseSaw']
          ? sawDiameter
          : dstPart.pathEdge?.includes('top') &&
            dstPart.pathEdge?.includes('bottom')
          ? diameter
          : sawDiameter
        // 还得给小板进行扩刀（扩完后需再按 ncSetting.decimal 保留小数）
        const decimal = store.state.ncSetting.decimal
        dstPart['rect']['width'] = toDecimal(
          dstPart['realRect']['width'] + d,
          decimal
        )
        dstPart['rect']['height'] = toDecimal(
          dstPart['realRect']['height'] + d,
          decimal
        )
      }
      // [锯切异形debug] 输出 startX/startY 调试信息 (需要时打开)
      // if (__dbgSaw) {
      //   const __bbox = (pts) => ({
      //     minX: Math.min(...pts.map((p) => p.x)),
      //     minY: Math.min(...pts.map((p) => p.y)),
      //     maxX: Math.max(...pts.map((p) => p.x)),
      //     maxY: Math.max(...pts.map((p) => p.y)),
      //   })
      //   const __gb = __bbox(dstPart['path'][0])
      //   const __rb =
      //     dstPart['srcPath'] && dstPart['srcPath'].length
      //       ? __bbox(dstPart['srcPath'])
      //       : null
      //   console.log('[锯切异形debug]', {
      //     id: dstPart['id'],
      //     startPosition: store.state.ncSetting.startPosition,
      //     rotate: dstPart['rotate'],
      //     bigPlank: { w: bigPlankWidth, h: bigPlankHeight },
      //     layoutRect: __dbgSaw,
      //     finalStartX: dstPart['startX'],
      //     finalStartY: dstPart['startY'],
      //     greenPathBBox: {
      //       ...__gb,
      //       w: +(__gb.maxX - __gb.minX).toFixed(2),
      //       h: +(__gb.maxY - __gb.minY).toFixed(2),
      //     },
      //     redPathBBox: __rb
      //       ? {
      //           ...__rb,
      //           w: +(__rb.maxX - __rb.minX).toFixed(2),
      //           h: +(__rb.maxY - __rb.minY).toFixed(2),
      //         }
      //       : null,
      //     oRect: dstPart['oRect'],
      //     realRect: dstPart['realRect'],
      //     rectAfter: dstPart['rect'],
      //     finalExtendDisMap,
      //     diameterXialiao: diameter,
      //     sawDiameter,
      //   })
      // }
      const partTexture = dstPart['texture']
      const partOriTexture = dstPart['oriTexture'] || dstPart['texture']

      // 开启了混排
      const oriBigTexture =
        otherPlate?.origin_color || surplusInfo?.origin_color || texture
      // 单个大板信息初始化的地方
      let newMargin
      // 余料新增修边 所以大板的修边需要考虑余料的修边 大板，标准板，余料板有自己的修边
      if (otherPlate && Object.keys(otherPlate).length) {
        newMargin = otherPlate.trim_edge
      } else if (
        surplusInfo &&
        Object.keys(surplusInfo).length &&
        !surplusInfo?.isNotSurplus
      ) {
        newMargin = surplusInfo.surplus_trim_edge
      } else {
        // 默认修边，采用标准板的修边
        newMargin = store.state.selectStandardPlank.plankEdgeOff
      }
      if (!container.hasOwnProperty(stockKey)) {
        container[stockKey] = {
          thick: thick,
          matCode: matCode,
          texture: texture,
          stockNum: stockNum,
          surplusInfo: surplusInfo,
          stockKey: stockKey,
          parts: [],
          plankWidth: bigPlankWidth,
          plankHeight: bigPlankHeight,
          otherPlate: otherPlate,
          highlight: dstPart?.is_high_gloss_plank ? '高光' : '非高光',
          // margin:
          //   otherPlate && Object.keys(otherPlate).length
          //     ? otherPlate.trim_edge
          //     : store.state.selectStandardPlank.plankEdgeOff,
          margin: newMargin,
          standardPlankId: store.state.selectStandardPlank.standard_plank_id,
          // 这张大板身上的小板的原始颜色
          oriTextures: [],
          // 这张大板可以表示的颜色
          allColors,
          // 根据颜色生成stockKey
          stockKeys: [],
          // 大板本身的颜色
          oriBigTexture,
          // 堆叠方式默认直接记录偏好设置中的堆叠方式
          stackingMethod:
            store.state.preferencesSetting.setting.stacking_method,
          brandName,
          supplierName,
          colorId: srcPart['colorId'] || '',
        }
        supplementBigPlankParam(container[stockKey], config)
      }

      // 给大板上增加代表混排的颜色
      if (partOriTexture && partTexture !== partOriTexture) {
        if (!container[stockKey]['oriTextures'].includes(partTexture)) {
          container[stockKey]['oriTextures'].push(partTexture)
        }
        if (!container[stockKey]['oriTextures'].includes(partOriTexture)) {
          container[stockKey]['oriTextures'].push(partOriTexture)
        }
      }

      // 处于混排状态的大板上增加stockKeys属性
      if (
        container[stockKey].allColors.length &&
        !container[stockKey].stockKeys.length
      ) {
        const stockKeys = container[stockKey].allColors.map(
          (color) =>
            `${color}:${container[stockKey].matCode}:${container[stockKey].thick}`
        )
        container[stockKey]['stockKeys'] = stockKeys
      }

      dstPart['startX'] = toDecimal(
        dstPart['startX'],
        store.state.ncSetting.decimal
      )
      // 给异形板件添加哪一些属性
      addPropForPart(dstPart, srcPart, store.state.ncSetting)
      container[stockKey]['parts'].push(dstPart)
      break
    }
  }
}

/**
 * 判断小板是否只加工孔槽不下料
 * @param {Object} processLine 生产线数据
 * @param {string} matCode 小板材质
 * @returns {boolean} 是否只有孔槽加工
 */
export function isOnlyProcessSlotAndHole(processLine, matCode) {
  if (!processLine) return false
  // 如果当前生产线开启了指定小板材质不下料，并且当前小板的材质在指定小板材质不下料的列表中，添加字段标识，同时还需满足加工方式是雕刻机仅下料，孔槽设备是五六面钻
  const {
    ncHoleSlot,
    dock56FDrill,
    is_des_material_no_cut,
    material_keywords_list,
    combinationEquip,
    cuttingEquipment,
  } = processLine.data
  /** 是否仅下料 */
  const isOnlyHoleSlot = ncHoleSlot === 'noHoleSlot'
  /** 是否是五六面钻加工设备 */
  const is56FDrill = dock56FDrill
  /** 是否是指定小板材质不下料 */
  const isNoCutMaterial = is_des_material_no_cut
  /** 是否是在指定小板材质不下料的列表中 */
  const isMatchMaterial = material_keywords_list.some((item) =>
    matCode.includes(item)
  )
  /** 下料设备只能是雕刻机 */
  const isEngraving = cuttingEquipment === 'engraving'
  /** 不能是组合设备 */
  const isNotCombinationEquip = !combinationEquip
  return (
    isOnlyHoleSlot &&
    is56FDrill &&
    isNoCutMaterial &&
    isMatchMaterial &&
    isNotCombinationEquip &&
    isEngraving
  )
}
/**
 * 检查排版数据中是否存在仅加工孔槽的板件
 * @param {*} processLine 可以不传
 * @param {*} paibanData
 * @returns
 */
export function checkIsOnlyProcessHoleSlotByPaibanData(
  paibanData,
  processLine
) {
  if (!processLine) {
    processLine = store.state.proLineList.find(
      (item) => item.id === store.state.ncSetting.process_setting_id
    )
  }
  return paibanData.some((item) =>
    isOnlyProcessSlotAndHole(processLine, item.matCode)
  )
}

// 给小板上添加属性,目前是分层切割
export const addPropForPart = (
  part,
  oriPart = {},
  ncSetting = store.state.ncSetting
) => {
  const {
    curve_layered_cutting_deep,
    secondCuttingDepth,
    minSafeLength,
    minSafeArea,
    minSafeThick,
    curve_layered_cutting,
    repeatedCut,
  } = ncSetting
  const { thick, path, rect } = part
  const { width, height } = rect
  if (matchLayeredCutForPalnkThick(part, ncSetting)) {
    part['curve_layered_cutting'] = true
    // 这个判断里面，后端不会使用这个属性，这里只是用来展示
    part['curve_layered_cutting_deep'] = 0
    return
  }

  // 后端之前使用的下料尺寸进行的判断
  const realWidth = width
  const realHeight = height
  // 给异形板件添加哪一些属性

  if (path) {
    // 异形板第二次切割的深度
    const deep = Reflect.has(oriPart, '_curve_layered_cutting_deep')
      ? oriPart['_curve_layered_cutting_deep']
      : Number(curve_layered_cutting_deep)
    const curveLayeredCuttingTemp = Reflect.has(
      oriPart,
      '_curve_layered_cutting'
    )
      ? oriPart['_curve_layered_cutting']
      : curve_layered_cutting

    part['curve_layered_cutting'] =
      deep >= thick ? false : curveLayeredCuttingTemp
    part['curve_layered_cutting_deep'] = deep
  } else {
    //普通板第二次切割的深度
    const deep = Reflect.has(oriPart, '_curve_layered_cutting_deep')
      ? oriPart['_curve_layered_cutting_deep']
      : Number(secondCuttingDepth)
    const curveLayeredCuttingTemp = Reflect.has(
      oriPart,
      '_curve_layered_cutting'
    )
      ? oriPart['_curve_layered_cutting']
      : repeatedCut

    part['curve_layered_cutting'] =
      deep >= thick ? false : curveLayeredCuttingTemp
    part['curve_layered_cutting_deep'] = deep
    // 说明是在排版页重新排版
    if (Reflect.has(oriPart, '_curve_layered_cutting')) return
    // 普通板件中长或者宽小于x，且面积小于y，则开启分层切割（只生效从开料清单排版）

    if (
      (realWidth >= Number(minSafeLength) &&
        realHeight >= Number(minSafeLength)) ||
      thick <= Number(minSafeThick) ||
      realWidth * realHeight >= Number(minSafeArea) * 1000 * 1000
    ) {
      part['curve_layered_cutting'] = false
    }
  }
  // 给线槽(自定义刀路)添加路径数据,扩张以及绘制数据(用于绘制和判断点位位置)
  if (part.lineSlots?.length) {
    for (const lineSlot of part.lineSlots) {
      const data = {
        path: lineSlot.path,
        width: lineSlot.width,
        isExpand: isLineSlotProcessPath(lineSlot),
      }
      // 线槽第一个点存在 b 值是错误的，所以要删除，因为柜柜他们有时候会将 B 值传入
      const copyData = window.$copy(data)
      Reflect.deleteProperty(copyData?.path[0], 'b')
      lineSlot.polygonArr = genExpandPathByBAndWidth(copyData)
    }
  }
  // 小板混排
  part['oriTexture'] = part['oriTexture'] || part['texture']
}

/**
 * @description 为带有 B 值的数据，同时存在宽度的路径进行扩板生成路径
 * @param {width: number, path: { x: number, y: number, b?: number }[]} data 路径数据
 * @returns {x: number, y: number }[] 扩板后的路径数据
 */
export const genExpandPathByBAndWidth = (data) => {
  const { path, width, isExpand } = data
  // 现将路径的B值部分转换成离散点位
  const flatPointList = dealPathCurve(path, Boolean(path?.[0]?.b))
  // 将线段按照宽度扩张成一个闭合图形,出现异常情况没有值则直接用原始的 path 来绘制
  const expandPath = isExpand
    ? dealLineSlotPath({ path: flatPointList, width }) ?? [flatPointList]
    : [flatPointList]
  return expandPath
}

// 判断小板是否满足大板板厚分层切割
export const matchLayeredCutForPalnkThick = (
  part,
  ncSetting = store.state.ncSetting
) => {
  const { layeredThickSetting } = ncSetting || {}

  if (!part || !layeredThickSetting) return false
  let { thick, matCode: partMatCode, is_high_gloss_plank } = part
  const { isLayeredCut, layeredThicks } = layeredThickSetting
  thick = thick ? String(thick) : ''
  // 正常小板有表示高光的字段， 余料小板没有
  let matCode = partMatCode ? String(partMatCode.replace('高光_', '')) : ''
  // 正常小板
  if (is_high_gloss_plank !== undefined) {
    is_high_gloss_plank = String(is_high_gloss_plank)
  } else {
    // 余料小板
    if (partMatCode.startsWith('高光_')) {
      is_high_gloss_plank = 'true'
      matCode = partMatCode.replace('高光_', '')
    } else {
      is_high_gloss_plank = 'false'
    }
  }

  const partKeys = [
    matCode,
    thick,
    is_high_gloss_plank,
    matCode + thick,
    matCode + is_high_gloss_plank,
    thick + is_high_gloss_plank,
    matCode + thick + is_high_gloss_plank,
  ]
  const isMatched = layeredThicks.some((item) => {
    const { pThick, matCode, highlight } = item
    const key = matCode + String(pThick) + String(highlight)
    return partKeys.some((partKey) => partKey === key)
  })
  return isLayeredCut && isMatched
}

/** 处理贴边槽扩板距离,返回板子上下左右需要扩的大小
 *
 * @param {*} part 小板数据
 * @param {*} ncSettings nc设置
 * @param {*} cutKnifeRadius 开料刀半径
 */
export function dealExpandSlot(part, ncSettings, cutKnifeRadius) {
  /** 扩板距离 */
  let extendDis = 0
  /** 记录各个方向的扩板距离 */
  const expandDisMap = {
    left: [],
    bottom: [],
    right: [],
    top: [],
    tb: [],
    lr: [],
  }

  /** 所有的槽 */
  const slots = part['slots']
  /** 常规扩板流程的槽 */
  const normalSlots = []
  /** 特殊扩板流程的槽（斜槽） */
  const specialSlots = []
  slots.forEach((slot) => {
    if (['CCompSlot'].includes(slot.symbol)) {
      specialSlots.push(slot)
    } else {
      normalSlots.push(slot)
    }
  })
  /** 所有的斜封边拉手和海棠角 */
  const handleSlopes = part['handleSlopes']
  /** 线槽(拉线槽/自定义刀路) */
  const lineSlots = part['lineSlots'] ?? []
  /** 是否预排版 */
  const isPreLayout = ncSettings.isPreLayout
  // 门套切割 排版间隙固定为0
  const isDoorFrame =
    ncSettings.sawSetting.mentaoji_enable &&
    ncSettings.sawSetting.processType === 'doorFrame' &&
    isSawPaiban(store)
  /** 排版间隙 */
  let layoutGap =
    part.isUseSaw && ncSettings.sawSetting.sawCutOnlyWeld
      ? ncSettings.sawSetting.sawBoardGap
      : ncSettings.panelSize.layoutGap
  layoutGap = isDoorFrame ? 0 : layoutGap

  // 铣底圆弧获取指定的刀
  const allKnifes = isPreLayout ? null : ncSettings && ncSettings.knives
  // 没刀具直接返回
  if (!allKnifes)
    return {
      left: 0,
      bottom: 0,
      right: 0,
      top: 0,
      extendLeft: 0,
      extendRight: 0,
    }
  // // 遍历所有的槽，在各个方向处理扩板，得到各个方向最大的扩板距离
  for (const index in normalSlots) {
    var slot = normalSlots[index]
    /** 指定刀具 */
    // 后端会找刀
    // const selectknife = slot?.knifeName
    const selectknife = slot?.knife_diameter
    const { realWidth, nearSide, type } = getSlotPositionInfo(slot, part)

    // 判断槽是横槽还是竖槽，靠哪边
    slot.nearSide = nearSide
    /** 指定刀具直径 */
    const selectKnifeDiameter = selectknife
    /** 检查是否满足扩版条件 */
    function checkIsNeedExpand(knifeDiameter) {
      // 看是否特殊槽，特殊槽(板件外部下刀）看直径，边缘下刀看半径
      const d = specialSymbol.includes(slot.symbol)
        ? knifeDiameter
        : knifeDiameter / 2
      // 贴边并且 d 大于开料刀直径加排版间隙
      return d > layoutGap + cutKnifeRadius * 2 && nearSide
    }

    if (selectknife) {
      /** 最终用于判断扩板的刀径 */
      const finalCutD = selectKnifeDiameter ? selectKnifeDiameter : realWidth
      /** 是否需要扩板 */
      const isNeedExpand = checkIsNeedExpand(finalCutD)
      if (isNeedExpand) {
        // 指定刀具情况下，特殊槽使用槽宽进行扩版计算(特殊规则下的槽需特殊处理)，普通槽使用指定刀具半径进行计算
        extendDis =
          (specialSymbol.includes(slot.symbol)
            ? finalCutD
            : selectKnifeDiameter / 2) -
          (layoutGap + cutKnifeRadius * 2)
      }
    }
    // 保证不会出现负数的扩板情况
    extendDis = extendDis > 0 ? extendDis : 0
    // 1、2、3、4 对应 左、下、右、上
    switch (nearSide) {
      case 1:
        expandDisMap.left.push(extendDis)
        break
      case 2:
        expandDisMap.bottom.push(extendDis)
        break
      case 3:
        expandDisMap.right.push(extendDis)
        break
      case 4:
        expandDisMap.top.push(extendDis)
        break
      default:
        if (type == 'horizontal') {
          expandDisMap.lr.push(extendDis * 2)
        } else {
          expandDisMap.tb.push(extendDis * 2)
        }
        break
    }
    extendDis = 0
  }
  // 槽扩板（目前只包含斜槽-需要包含其他普通槽需要2026-12-22日之后替换(避免历史记录的影响)）
  for (const slot of specialSlots) {
    const { pt1, pt2, knife_diameter, width, symbol } = slot
    const outLine = rectToPath(part.realRect)
    const useKnifeDiameter =
      getSlotUseKnife(knife_diameter, width, allKnifes)?.diameter ?? 0
    const { machiningType, isKnifeInPath } = getSlotMachiningType(
      useKnifeDiameter,
      width,
      [pt1, pt2],
      outLine
    )
    const offset = getUseKnifeDiameter(symbol, isKnifeInPath, useKnifeDiameter)
    // 如果是拉槽那么始终使用 pt 点作为是否超出板件的判断值,不考虑槽一部分在外面的情况
    const slopePath =
      machiningType === 'pull'
        ? [pt1, pt2]
        : calculateSlantedRectanglePath(pt1, pt2, width).path
    const nExpandDisMap = standardPathExpand(
      outLine,
      slopePath,
      cutKnifeRadius,
      layoutGap,
      offset
    )
    for (const [side, expandDis] of Object.entries(nExpandDisMap)) {
      expandDisMap[side].push(...expandDis)
    }
  }
  // 遍历所有的斜封边拉手和海棠角，在各个方向处理扩板，得到各个方向最大的扩板距离
  /** 是否单独生成海棠角加工文件 */
  const isHandleSlpoeSingleFile = ncSettings.singleFileSetting.handleSlope
  if (!isHandleSlpoeSingleFile) {
    for (const index in handleSlopes) {
      const handleSlope = handleSlopes[index]
      // 直接判断贴边方向
      const partWidth = part.oRect.width
      const partHeight = part.oRect.height
      let nearSide = 0
      const { opt1, opt2 } = handleSlope
      if (Math.abs(opt1.x - opt2.x) < 0.01) {
        if (opt1.x < 0.01) {
          nearSide = 1
        } else if (opt1.x > partWidth - 0.01) {
          nearSide = 3
        }
      } else {
        if (opt1.y < 0.01) {
          nearSide = 4
        } else if (opt1.y > partHeight - 0.01) {
          nearSide = 2
        }
      }

      const selectKnifeDiameter =
        ncSettings.knives[handleSlope.knife]?.diameter ?? 0

      const selectKnifeR = selectKnifeDiameter / 2
      const isNeedExpand =
        nearSide && selectKnifeR > layoutGap + cutKnifeRadius * 2
      const expandDis = isNeedExpand
        ? selectKnifeR - (layoutGap + cutKnifeRadius * 2)
        : 0
      switch (nearSide) {
        case 1:
          expandDisMap.left.push(expandDis)
          expandDisMap.tb.push(expandDis * 2)
          break
        case 2:
          expandDisMap.bottom.push(expandDis)
          expandDisMap.lr.push(expandDis * 2)
          break
        case 3:
          expandDisMap.right.push(expandDis)
          expandDisMap.tb.push(expandDis * 2)
          break
        case 4:
          expandDisMap.top.push(expandDis)
          expandDisMap.lr.push(expandDis * 2)
          break
      }
    }
  }
  // 线槽扩板主体流程和槽差不多，但是又有部分区别，最终还是选择独立出来
  for (const ls of lineSlots) {
    // 计算线槽需要扩板的距离(距边最近的点和边的距离 > 刀径+间隙 就要扩 距离 - (刀径+间隙))
    const { path, width, knifeType, twoStep } = ls
    // 二次加工不扩版
    if (twoStep) continue
    const realPath = rectToPath(part.realRect)
    // 刀类型为铣槽刀或钻头，走普通拉槽逻辑，造型刀走板外下刀逻辑，所以是直径
    const offset = ['mill', 'dill'].includes(knifeType) ? width / 2 : width
    const result = standardPathExpand(
      realPath,
      path,
      cutKnifeRadius,
      layoutGap,
      offset
    )
    for (const [side, distance] of Object.entries(result)) {
      expandDisMap[side].push(...distance)
    }
  }

  /** 处理默认值，长度为 0 的不扩，不为 0 取其中的最大值来扩版 */
  function dealDefaultVal(arr) {
    return arr.length ? Math.max(...arr) : 0
  }
  /** 四周扩板最大值计算 */
  const maxExtandDisMap = {
    left: dealDefaultVal(expandDisMap.left),
    bottom: dealDefaultVal(expandDisMap.bottom),
    right: dealDefaultVal(expandDisMap.right),
    top: dealDefaultVal(expandDisMap.top),
    tb: dealDefaultVal(expandDisMap.tb), // tb为上下
    lr: dealDefaultVal(expandDisMap.lr), // lr为左右
  }
  // 得到各个方向的扩版后还要与左右、上下这种拉通的扩版距离做比较，取较大值
  const finalExtendDisMap = {
    left: toDecimal(
      maxExtandDisMap.left > maxExtandDisMap.lr / 2
        ? maxExtandDisMap.left
        : maxExtandDisMap.lr / 2,
      2
    ),
    bottom: toDecimal(
      maxExtandDisMap.bottom > maxExtandDisMap.tb / 2
        ? maxExtandDisMap.bottom
        : maxExtandDisMap.tb / 2,
      2
    ),
    right: toDecimal(
      maxExtandDisMap.right > maxExtandDisMap.lr / 2
        ? maxExtandDisMap.right
        : maxExtandDisMap.lr / 2,
      2
    ),
    top: toDecimal(
      maxExtandDisMap.top > maxExtandDisMap.tb / 2
        ? maxExtandDisMap.top
        : maxExtandDisMap.tb / 2,
      2
    ),
  }
  dealExplankSlotForSawPaiban(finalExtendDisMap, part)
  return finalExtendDisMap
}

/**
 * @description 排版页面重新排版这个操作对于排版页面的槽数据来说因为进行了偏移
 * 导致位置会有一定程度的不正确，无法计算正确的扩板值先需要(rect-realRect)得到究竟偏移了多少，然后将槽（普通槽/线槽）的位置偏移回来再计算槽超出板件多少
 * 此做法需满足板件扩板都是两边一起扩而不是单边扩，如果有单边扩的情况，一定记得保留数据
 * @param {*} part 小板数据
 * @param {*} ncSettings nc设置
 * @param {*} cutKnifeRadius 开料刀半径
 */
export function dealExpandSlotForPaiban(part, ncSettings, cutKnifeRadius) {
  const { slots = [], lineSlots = [] } = part
  const nSlots = window.$copy(slots)
  const nLineSlots = window.$copy(lineSlots)

  // 检查斜槽是否存在 oriPt1 和 oriPt2
  const obliqueSlotsWithoutOri = nSlots.filter(
    (slot) =>
      ['CCompSlot'].includes(slot.symbol) && (!slot.oriPt1 || !slot.oriPt2)
  )

  if (obliqueSlotsWithoutOri.length > 0) {
    throw new Error(`重新排版数据错误：请在开料清单页面重新排版`)
  }

  // 检查线槽是否存在 oriPath
  const lineSlotsWithoutOri = nLineSlots.filter((ls) => !ls.oriPath)

  if (lineSlotsWithoutOri.length > 0) {
    throw new Error(`重新排版数据错误：请在开料清单页面重新排版`)
  }

  // 检查通过，将 ori 数据赋值给原本的 pt 和 path
  nSlots.forEach((slot) => {
    if (slot.oriPt1) {
      slot.pt1 = window.$copy(slot.oriPt1)
    }
    if (slot.oriPt2) {
      slot.pt2 = window.$copy(slot.oriPt2)
    }
  })

  nLineSlots.forEach((ls) => {
    if (ls.oriPath) {
      ls.path = window.$copy(ls.oriPath)
    }
  })

  const nPart = { ...part, slots: nSlots, lineSlots: nLineSlots }
  const finalExtendDisMap = dealExpandSlot(nPart, ncSettings, cutKnifeRadius)
  return finalExtendDisMap
}

/**
 * @description 为什么要这么处理？为了保持和直接排板中槽的逻辑一致性，
 * 和焊接板排相同宽度，针对于焊接板宽度上不进行扩板，
 * 只在高度上进行扩板，因为焊接板是排单列的
 * 焊接板槽扩板的额外处理
 * @param finalExtendDisMap 槽扩板的最终处理结果
 */
function dealExplankSlotForSawPaiban(finalExtendDisMap, part) {
  const sawToLayout =
    store.state.ncSetting.sawSetting.mentaoji_enable &&
    store.state.ncSetting.sawSetting.sawToLayout &&
    isSawPaiban(store)
  const sawCutOnlyWeld =
    store.state.ncSetting.sawSetting.sawCutOnlyWeld &&
    store.state.ncSetting.sawSetting.mentaoji_enable &&
    store.state.ncSetting.sawSetting.sawToLayout &&
    store.state.ncSetting.sawSetting.processType === 'weldingPlank'

  if (
    (sawToLayout && !sawCutOnlyWeld) ||
    (sawToLayout && sawCutOnlyWeld && part.isWeldingPlank)
  ) {
    const expandDisMap = dealExpandPathForPart(part)
    finalExtendDisMap.left += expandDisMap.left
    finalExtendDisMap.right += expandDisMap.right
    finalExtendDisMap.top += expandDisMap.top
    finalExtendDisMap.bottom += expandDisMap.bottom
  }
}

/**
 * 得到异形小板通过下料刀扩版后，四周相较于下料刀半径偏移多的误差值
 * @param {*} part
 * @returns
 */
export function dealExpandPathForPart(part, diameter = 0) {
  if (part.path && part.srcPath) {
    const stockKey = `${part.texture}:${part.matCode}:${part.thick}`
    const cutDiameter = diameter
      ? diameter
      : getPlateKnifeDiameter(stockKey, store.state.ncSetting)
    const cutKnifeRadius = cutDiameter / 2
    const srcPath = closePath(window.$copy(part.srcPath))

    // srcPath 含 b 值弧线时需先离散，否则 expandPath 会按弦线扩版导致结果错误
    let flatPath = part.srcPath ?? part.path[0]

    const upperPath = window
      .$copy(flatPath)
      .map((p) => ({ ...p, X: p.x, Y: p.y }))
    const expandedRes = expandPath(cutKnifeRadius, upperPath)
    const expandedPath = expandedRes[0]
    if (!expandedPath?.length) {
      return { left: 0, right: 0, top: 0, bottom: 0 }
    }
    const { min, max } = getPathMinMax(expandedPath)
    const minY = min.y
    const maxY = max.y
    const minX = min.x
    const maxX = max.x

    const { min: srcMin, max: srcMax } = getPathMinMax(srcPath)
    const srcMinX = srcMin.x
    const srcMaxX = srcMax.x
    const srcMinY = srcMin.y
    const srcMaxY = srcMax.y

    const topDis = srcMinY - minY - cutKnifeRadius
    const bottomDis = maxY - srcMaxY - cutKnifeRadius
    const leftDis = srcMinX - minX - cutKnifeRadius
    const rightDis = maxX - srcMaxX - cutKnifeRadius
    const res = {
      left: Number(leftDis.toFixed(3)),
      right: Number(rightDis.toFixed(3)),
      top: Number(topDis.toFixed(3)),
      bottom: Number(bottomDis.toFixed(3)),
    }
    return res
  }
  return { left: 0, right: 0, top: 0, bottom: 0 }
}

/**
 * @description 目前所有的槽的获取刀逻辑,存在指定刀获取指定刀，否则获取可以拉槽的刀(slotWidth=knife)用于拉槽,否则获取小于槽宽的刀(slotWidth>knife)用于铣槽
 * @param {String} knifeDiameter 指定刀具直径
 * @param {Number} slotWidth 槽宽
 * @param {object} knifes 刀具列表
 * @returns { object } 可以使用的刀具
 */
function getSlotUseKnife(knifeDiameter, slotWidth, knifes) {
  // 存在指定刀直径则直接使用直径
  if (knifeDiameter || knifeDiameter === 0) {
    return { diameter: knifeDiameter }
  }
  const findKnifeByKnifeDiameter = (width, operator = '=') => {
    const knifeArr = Object.values(knifes ?? {})
    return knifeArr.find((v) => compareNumbers(v.diameter, width, operator))
  }
  // 首选拉槽
  const pullKnife = findKnifeByKnifeDiameter(slotWidth)
  if (pullKnife) return { diameter: pullKnife?.diameter }
  // 铣槽
  return { diameter: findKnifeByKnifeDiameter(slotWidth, '<')?.diameter }
}

/**
 * @description 获取槽下刀的大小，按照刀走位置，如果刀走槽的路径(一般是拉,某些铣槽也是走路径),则需要半个刀径，但某些特殊槽需要外部下刀则是一整个刀径
 */
function getUseKnifeDiameter(symbol, isKnifeInPath, useKnifeDiameter) {
  if (!isKnifeInPath) return 0
  // 拉直器那些为板外下刀则是整个刀
  if (specialSymbol.includes(symbol)) {
    return useKnifeDiameter
  }
  // 普通拉槽则是半个刀
  return useKnifeDiameter / 2
}

/**
 * @description 获取此槽加工方式（适用于常规槽）
 * @param {*} knifeDiameter
 * @param {*} slotWidth
 * @param {Array<{x: number, y: number}>} slotPath 槽路径 -> 当槽的 pt或opt点位在板件外则算做拉槽的加工方式
 * @param {Array<{x: number, y: number}>} rectPath 板件轮廓路径 可以是 rect 或者 orect
 * @returns { { machiningType: 'mill' | 'pull', isKnifeInPath: boolean } } 加工方式  machiningType 刀走路径是否在槽上而不是槽内isKnifeInPath
 */
function getSlotMachiningType(knifeDiameter, slotWidth, slotPath, rectPath) {
  const machiningType = compareNumbers(knifeDiameter, slotWidth, '<')
    ? 'mill'
    : 'pull'
  const result = {
    machiningType,
    isKnifeInPath: machiningType === 'pull',
  }
  if (result.machiningType === 'mill') {
    // 如果是铣槽加工模式，但是槽的点位(pt)是在板件外,或贴边那么应该按照刀进行扩板以及相关操作，因为这槽后端不会内缩
    if (!isPathStrictlyInside(slotPath, rectPath)) {
      result.isKnifeInPath = true
    }
  }
  return result
}
/**
 * @description 处理一个标准槽位路径的扩板操作
 * @param {Array} rectPath 板件下料路径
 * @param {Array} path 标准路径
 * @param {Number} cutKnifeRadius 下料刀半径
 * @param {Number} layoutGap 排版间隙
 * @param {Number} offset 标准路径内部的点位数据，是否还需要一个额外的偏移，例如：拉槽拉穿还需要再加上一个刀半径，而斜槽的铣槽方式则不需要
 * @returns {left, top, right, bottom} 对应位置的扩板距离
 */
function standardPathExpand(
  rectPath,
  path,
  cutKnifeRadius,
  layoutGap,
  offset = 0
) {
  const expandDisMap = {
    left: [],
    top: [],
    right: [],
    bottom: [],
  }
  path.forEach((point) => {
    const distances = getClosestRectEdgeWithPoint(rectPath, point)
    for (const [side, info] of Object.entries(distances)) {
      let { distance } = info
      distance = distance + offset
      // 距边距离只有小于 0 才代表槽会到外部去
      if (distance < 0) continue
      distance = Math.abs(distance)
      // 一个标准计算方式：计算槽减去刀径损耗和间隙后是否还需要扩刀
      const expandDistance = distance - (cutKnifeRadius * 2 + layoutGap)
      // 扩张距离大于 0 才标明需要添加扩张距离
      if (expandDistance > 0) {
        expandDisMap[side].push(expandDistance)
      }
    }
  })
  return expandDisMap
}

// -------- 外部异形边检测（pathEdge）--------
// realCurve 为后端坐标（左下角原点）；pathEdge 供排版页使用（左上角原点，仅上下与后端对调）。
// 判定：外接矩形 Clipper 裁掉板件路径后，剩余区贴到外接矩形哪一边，该边才为异形。
// pathEdge 用于锯切扩刀等。

/** 与排版常用小数位对齐，避免裁剪取整后对不上 */
const PATH_EDGE_EPS = 0.01

function isNearPathNum(a, b, eps = PATH_EDGE_EPS) {
  return Math.abs(a - b) < eps
}

/** 去掉闭合路径首尾重复点，避免角点被重复计数 */
function normalizeRealCurvePoints(realCurve) {
  if (!realCurve?.length) return []
  const points = [...realCurve]
  if (points.length > 1) {
    const first = points[0]
    const last = points[points.length - 1]
    if (isNearPathNum(first.x, last.x) && isNearPathNum(first.y, last.y)) {
      points.pop()
    }
  }
  return points
}

/** 计算点集的外接矩形边界（避免大数组 Math.min(...arr) 展开爆栈） */
function getPathBounds(points) {
  let minX = Infinity
  let maxX = -Infinity
  let minY = Infinity
  let maxY = -Infinity
  for (let i = 0; i < points.length; i++) {
    const { x, y } = points[i]
    if (x < minX) minX = x
    if (x > maxX) maxX = x
    if (y < minY) minY = y
    if (y > maxY) maxY = y
  }
  return { minX, maxX, minY, maxY }
}

/** 外接矩形转闭合路径，供 Clipper 裁剪 */
function getBoundsRectPath(bounds) {
  const { minX, maxX, minY, maxY } = bounds
  return [
    { x: minX, y: minY },
    { x: maxX, y: minY },
    { x: maxX, y: maxY },
    { x: minX, y: maxY },
  ]
}

function closePolygonForClip(polygon) {
  if (!polygon?.length) return []
  const closed = polygon.map((p) => ({ x: p.x, y: p.y }))
  const first = closed[0]
  const last = closed[closed.length - 1]
  if (!isNearPathNum(first.x, last.x) || !isNearPathNum(first.y, last.y)) {
    closed.push({ x: first.x, y: first.y })
  }
  return closed
}

/**
 * 外接矩形裁剪掉板件多边形后的剩余路径（图中红色阴影）
 * 忽略面积过小的数值缝隙
 */
function clipBoundsMinusPolygon(bounds, polygon) {
  if (!ClipperLib || !polygon?.length) return []

  const width = bounds.maxX - bounds.minX
  const height = bounds.maxY - bounds.minY
  if (width <= PATH_EDGE_EPS || height <= PATH_EDGE_EPS) return []

  try {
    const SCALE = 10000
    const closed = closePolygonForClip(polygon)
    const subject = [getBoundsRectPath(bounds).map((p) => ({ X: p.x, Y: p.y }))]
    const clip = [closed.map((p) => ({ X: p.x, Y: p.y }))]
    ClipperLib.JS.ScaleUpPaths(subject, SCALE)
    ClipperLib.JS.ScaleUpPaths(clip, SCALE)

    const cpr = new ClipperLib.Clipper()
    cpr.PreserveCollinear = true
    cpr.AddPaths(subject, ClipperLib.PolyType.ptSubject, true)
    cpr.AddPaths(clip, ClipperLib.PolyType.ptClip, true)
    const solution = new ClipperLib.Paths()
    cpr.Execute(
      ClipperLib.ClipType.ctDifference,
      solution,
      ClipperLib.PolyFillType.pftEvenOdd,
      ClipperLib.PolyFillType.pftEvenOdd
    )

    const leftoverMinArea = 0.01
    // Clipper.Area 读的是小写 x/y，不能传 X/Y，否则面积为 NaN 会被全部滤掉
    return JSON.parse(JSON.stringify(solution))
      .map((path) =>
        path.map((p) => ({
          x: p.X / SCALE,
          y: p.Y / SCALE,
        }))
      )
      .filter((path) => {
        if (path.length < 3) return false
        const area = Math.abs(ClipperLib.Clipper.Area(path))
        return Number.isFinite(area) && area > leftoverMinArea
      })
  } catch (err) {
    console.log(err)
    return []
  }
}

/** 绿色路径顶点或边上是否出现该坐标轴取值 */
function pathHasCoord(points, axis, value, eps = PATH_EDGE_EPS) {
  if (!points?.length) return false
  const count = points.length
  for (let i = 0; i < count; i++) {
    const p1 = points[i]
    const v1 = axis === 'x' ? p1.x : p1.y
    if (isNearPathNum(v1, value, eps)) return true
    const p2 = points[(i + 1) % count]
    const v2 = axis === 'x' ? p2.x : p2.y
    const min = Math.min(v1, v2)
    const max = Math.max(v1, v2)
    if (value >= min - eps && value <= max + eps) return true
  }
  return false
}

/**
 * 在后端坐标系下分析外轮廓的异形边
 *
 * 用外接矩形 Clipper 裁掉板件路径，得到剩余红色区域。
 * 仅当剩余区贴到外接矩形的某一边（leftover 与 outer 的对应极值接近）时，
 * 该边才算异形；避免把凹口侧壁的 minX/maxX/minY 误判成左/右/下异形。
 *
 * @param {Array} realCurve 带封边的外部轮廓
 * @returns {Array<'bottom'|'top'|'left'|'right'>} 后端坐标系下的异形边列表
 */
function getBackendAbnormalEdges(realCurve) {
  const vertices = normalizeRealCurvePoints(realCurve)
  if (!vertices.length) return []

  let greenPath = vertices
  try {
    const tessellated = dealPathCurve(realCurve) || []
    if (tessellated.length) {
      greenPath = normalizeRealCurvePoints(tessellated)
    }
  } catch (err) {
    console.log(err)
  }
  if (!greenPath.length) return []

  const bounds = getPathBounds(greenPath)
  const leftoverPaths = clipBoundsMinusPolygon(bounds, greenPath)
  if (!leftoverPaths.length) return []

  const leftoverPoints = leftoverPaths.flat()
  if (!leftoverPoints.length) return []
  const leftoverBounds = getPathBounds(leftoverPoints)

  const edgeChecks = [
    {
      edge: 'left',
      leftoverVal: leftoverBounds.minX,
      outerVal: bounds.minX,
      axis: 'x',
    },
    {
      edge: 'right',
      leftoverVal: leftoverBounds.maxX,
      outerVal: bounds.maxX,
      axis: 'x',
    },
    {
      edge: 'bottom',
      leftoverVal: leftoverBounds.minY,
      outerVal: bounds.minY,
      axis: 'y',
    },
    {
      edge: 'top',
      leftoverVal: leftoverBounds.maxY,
      outerVal: bounds.maxY,
      axis: 'y',
    },
  ]

  const abnormalSet = new Set()
  edgeChecks.forEach(({ edge, leftoverVal, outerVal, axis }) => {
    // 剩余区必须贴到外接矩形该边，凹口内沿不计入异形边
    if (!isNearPathNum(leftoverVal, outerVal)) return
    if (
      pathHasCoord(greenPath, axis, leftoverVal) ||
      pathHasCoord(vertices, axis, leftoverVal)
    ) {
      abnormalSet.add(edge)
    }
  })

  return Array.from(abnormalSet)
}

/**
 * 后端坐标系 → 排版页坐标系
 * 后端左下角原点、前端左上角原点，Y 轴反向，故仅 top/bottom 对调，left/right 不变
 */
function backendEdgesToFrontend(edges) {
  return edges.map((edge) => {
    if (edge === 'top') return 'bottom'
    if (edge === 'bottom') return 'top'
    return edge
  })
}

/**
 * @description 找出外部异形所在边，写入 part.pathEdge
 * @param {*} part 小板数据（需含 realCurve）
 * @returns {*} 异形板返回带 pathEdge 的 part，非异形不处理
 */
export function exterPathEdgeForPart(part) {
  if (!isExternalPath(part)) return

  part.pathEdge = backendEdgesToFrontend(
    getBackendAbnormalEdges(part.realCurve)
  )
  return part
}

/**
 * 判断多边形顶点的排列顺序（顺时针或逆时针）
 * @param {Array} points 多边形顶点数组，每个顶点为{x: number, y: number}
 * @returns {Boolean} true => 顺时针   false => 逆时针
 */
function isClockwise(points) {
  // 手动闭合路径（若未闭合）
  const closedPath = [...points]
  if (
    closedPath[0].x !== closedPath[closedPath.length - 1].x ||
    closedPath[0].y !== closedPath[closedPath.length - 1].y
  ) {
    closedPath.push(closedPath[0]) // 追加第一个点作为终点，形成闭合
  }

  let sum = 0
  for (let i = 0; i < closedPath.length - 1; i++) {
    // 此时遍历到倒数第二个点（原最后一个点）
    sum +=
      (closedPath[i + 1].x - closedPath[i].x) *
      (closedPath[i + 1].y + closedPath[i].y)
  }
  return sum > 0
}

/**
 * @description 用于判断一个小板是否是一个外部异形
 * @param {*} part 小板数据, realCurve 描述的是带封边的外部轮廓
 * @returns {Boolean} true | false
 */
export const isExternalPath = (part) => {
  if (!part?.realCurve || part.realCurve.length === 0) {
    return false
  }
  const { realCurve } = part

  // 检查是否有曲线段（含b值且b≠0表示曲线）
  const hasCurveSegment = realCurve.some((point) => {
    // b可能为数字或字符串，统一转为数字判断
    const bValue = Number(point.b)
    return !isNaN(bValue) && bValue !== 0
  })
  if (hasCurveSegment) {
    return true // 有曲线段一定是外部异形
  }

  // 检查顶点数量（矩形通常最多5个点：4个顶点+闭合重复点）
  // 去重后超过4个顶点，基本可判定为异形
  const uniquePoints = [...realCurve]
  if (
    uniquePoints[0].x === uniquePoints[uniquePoints.length - 1].x &&
    uniquePoints[0].y === uniquePoints[uniquePoints.length - 1].y
  ) {
    uniquePoints.pop()
  }
  if (uniquePoints.length > 4) {
    return true
  }
  // 用顶点构造出外接矩形
  const rect = getRectFromPoints(uniquePoints)

  // uniquePoints 缺少rect四个顶点的其中一个就判定为外部异形
  const externalFlag = rect.some((p) => {
    if (!uniquePoints.some((point) => point.x === p.x && point.y === p.y)) {
      return true
    }
    return false
  })
  return externalFlag
  // 最终验证：检查是否为标准矩形（排除矩形的情况）
  if (!isRectangle(realCurve)) {
    return true // 不是标准矩形，判定为异形
  }

  // 所有条件都不满足，判定为非外部异形
  return false
}

const getRectFromPoints = (points) => {
  const minX = Math.min(...points.map((point) => point.x))
  const minY = Math.min(...points.map((point) => point.y))
  const maxX = Math.max(...points.map((point) => point.x))
  const maxY = Math.max(...points.map((point) => point.y))
  return [
    { x: minX, y: minY },
    { x: minX, y: maxY },
    { x: maxX, y: minY },
    { x: maxX, y: maxY },
  ]
}

/**
 * @description 判断一组点是否构成标准矩形（轴对齐或旋转矩形）
 * @param {Array} points 形状描述点位
 * @returns {Boolean} 是否为矩形
 */
const isRectangle = (points) => {
  if (!points || points.length < 4) return false

  // 去重首尾重复点（闭合形状通常首尾相同）
  const uniquePoints = [...points]

  if (uniquePoints.length !== 4) return false

  // 计算向量
  const getVector = (p1, p2) => ({
    x: p2.x - p1.x,
    y: p2.y - p1.y,
  })

  // 计算相邻边向量
  const v1 = getVector(uniquePoints[0], uniquePoints[1])
  const v2 = getVector(uniquePoints[1], uniquePoints[2])
  const v3 = getVector(uniquePoints[2], uniquePoints[3])
  const v4 = getVector(uniquePoints[3], uniquePoints[0])

  // 计算点积（判断垂直）
  const dotProduct = (v1, v2) => v1.x * v2.x + v1.y * v2.y

  // 相邻边应垂直（点积接近0）
  const isPerpendicular = (v1, v2) => Math.abs(dotProduct(v1, v2)) < 1e-6

  // 对边应平行（向量叉积接近0）
  const crossProduct = (v1, v2) => v1.x * v2.y - v1.y * v2.x
  const isParallel = (v1, v2) => Math.abs(crossProduct(v1, v2)) < 1e-6

  // 矩形: 相邻边垂直，对边平行且等长
  return (
    isPerpendicular(v1, v2) &&
    isPerpendicular(v2, v3) &&
    isPerpendicular(v3, v4) &&
    isPerpendicular(v4, v1) &&
    isParallel(v1, v3) &&
    isParallel(v2, v4) &&
    Math.hypot(v1.x, v1.y) === Math.hypot(v3.x, v3.y) && // 对边长度相等
    Math.hypot(v2.x, v2.y) === Math.hypot(v4.x, v4.y)
  )
}

/**
 * @description 根据点位判断是否是一个首尾闭合的形状
 * @param {Array} points 形状描述点位，每个点包含x、y属性
 * @param {number} tolerance 误差容忍度
 * @returns {Boolean} true | false
 */
export const isClosedShape = (points, tolerance = 1e-6) => {
  if (!points || points.length <= 3) {
    return false
  }

  const first = points[0]
  const last = points[points.length - 1]

  // 检查首尾点的x和y是否在允许误差范围内
  return (
    Math.abs(first.x - last.x) < tolerance &&
    Math.abs(first.y - last.y) < tolerance
  )
}
/** 获取槽的距边方向等信息 */
export function getSlotPositionInfo(slot, part) {
  const { opt1, opt2, width } = slot
  const { oRect } = part
  /** x 轴方向长度 */
  const slotW = Math.abs(opt1.x - opt2.x)
  /** y 轴方向长度 */
  const slotH = Math.abs(opt1.y - opt2.y)
  /** 横：horizontal  竖：vertical */
  let type = 'horizontal'
  /** 真实宽度 */
  let realWidth = width
  /** 真实长度 */
  let realLong = width
  // x 相等
  if (!slotW) {
    if (slotH < width) {
      type = 'horizontal'
      realWidth = slotH
    } else {
      type = 'vertical'
      realLong = slotH
    }
  } else {
    // y 相等
    if (slotW < width) {
      type = 'vertical'
      realWidth = slotW
    } else {
      type = 'horizontal'
      realLong = slotW
    }
  }

  realLong = Number(Number(realLong).toFixed(4))
  /** 槽最终的贴边方向 方向分别是 左下右上：1234 拉通的为5 */
  let nearSide = 0
  /** 记录槽的贴边方向 没有贴边就为空， */
  const nearSideList = []
  // 如果是横槽，判断左右是否接近或超出
  if (type == 'horizontal') {
    const minX = Math.min(opt1.x, opt2.x)
    const maxX = Math.max(opt1.x, opt2.x)
    if (minX <= 0.01) {
      nearSideList.push(1)
    }
    if (maxX >= oRect.width - 0.01) {
      nearSideList.push(3)
    }
  } else {
    // 竖槽，则判断上下是否接近或超出
    const minY = Math.min(opt1.y, opt2.y)
    const maxY = Math.max(opt1.y, opt2.y)
    if (minY < 0.01) {
      nearSideList.push(4)
    }
    if (maxY >= oRect.height - 0.01) {
      nearSideList.push(2)
    }
  }

  if (nearSideList.length == 2) {
    nearSide = 5
  } else if (nearSideList.length) {
    nearSide = nearSideList[0]
  }

  return {
    realWidth,
    type,
    nearSide,
    realLong,
  }
}

// 根据nc设置处理槽摆放位置
export function changeSlotsPositionByNCsetting(
  dstPart,
  plankWidth,
  plankHeight
) {
  let needRota = false
  // 异形板件不进行处理
  if (ncConfig.sideBoardPlacing == 'outside' && !dstPart.path) {
    let safeDis = 100
    let startX = dstPart.startX
    let startY = dstPart.startY
    let slots = dstPart.slots
    for (var i in slots) {
      var slot = slots[i]
      var pt1 = slot.pt1
      var pt2 = slot.pt2
      if (Math.abs(pt1.x - pt2.x) <= 0.000001) {
        if (startX + pt1.x < safeDis) {
          needRota = true
          break
        } else if (
          startX + dstPart.rect.width + 20 > plankWidth &&
          startX + pt1.x < plankWidth - dstPart.rect.width / 2
        ) {
          needRota = true
          break
        } else if (startX <= 0) {
          needRota = true
          break
        }
      } else if (Math.abs(pt1.y - pt2.y) <= 0.000001) {
        if (startY + pt1.y < safeDis) {
          needRota = true
          break
        } else if (
          startY + dstPart.rect.height + 20 > plankHeight &&
          startY + pt1.y < plankHeight - dstPart.rect.height / 2
        ) {
          needRota = true
          break
        } else if (startY <= 0) {
          needRota = true
          break
        }
      }
    }
  }

  return needRota
}
//调整原点
function changePositionCutOrigin(
  dstPart,
  tmpValue,
  tmpValue2,
  tmpValueLeft,
  tmpValue2Left,
  plankWidth,
  plankHeight,
  sawDiameter,
  diameter,
  sawToLayout, // 锯切排版
  sawCutOnlyWeld
) {
  var startX = dstPart['startX']
  var startY = dstPart['startY']
  var rectWidth = dstPart['rect']['width'] // 锯切排版下这里是 reacRectWidth, 非锯切排板下这里是 rectHeight(realRect + d + 槽)
  var rectHeight = dstPart['rect']['height'] // 锯切排版下这里是 realRectHeight + 槽, 非锯切排板下这里是 rectHeight(realRect + d + 槽)
  const realRectHeight = dstPart['realRect']['height']
  let D // 表示的是算法那边的大板扩刀
  if (sawToLayout) {
    D = sawDiameter
  } else {
    D = diameter
  }
  const d = dstPart['isUseSaw']
    ? sawDiameter
    : dstPart['pathEdge']?.includes('top') &&
      dstPart['pathEdge']?.includes('bottom')
    ? diameter
    : sawDiameter
  var curStartPositon = store.state.ncSetting.startPosition
  // 调整排版原点
  if (
    sawToLayout &&
    ((sawCutOnlyWeld && dstPart.isWeldingPlank) || !sawCutOnlyWeld)
  ) {
    const expandDisMap = dealExpandPathForPart(dstPart, d)
    if (curStartPositon === '左上角') {
      dstPart['startY'] += tmpValue2 - D / 2
      dstPart['startX'] += tmpValue2Left - D / 2
    } else if (curStartPositon === '左下角') {
      dstPart['startY'] =
        plankHeight +
        D / 2 -
        (startY + realRectHeight + expandDisMap.top + d / 2)
      dstPart['startX'] += tmpValue2Left - D / 2
    } else if (curStartPositon === '右下角') {
      dstPart['startX'] =
        plankWidth + D / 2 - (startX + rectWidth + expandDisMap.right + d / 2)
      dstPart['startY'] =
        plankHeight +
        D / 2 -
        (startY + realRectHeight + expandDisMap.top + d / 2)
    } else if (curStartPositon === '右上角') {
      dstPart['startX'] =
        plankWidth + D / 2 - (startX + rectWidth + expandDisMap.right + d / 2)
      dstPart['startY'] += tmpValue2 - D / 2
    }
  } else {
    if (curStartPositon === '左上角') {
      dstPart['startY'] += tmpValue2
      dstPart['startX'] += tmpValue2Left
    } else if (curStartPositon === '左下角') {
      dstPart['startY'] = plankHeight - (startY + rectHeight) - tmpValue
      dstPart['startX'] += tmpValue2Left
    } else if (curStartPositon === '右下角') {
      dstPart['startX'] = plankWidth - (startX + rectWidth) - tmpValueLeft
      dstPart['startY'] = plankHeight - (startY + rectHeight) - tmpValue
    } else if (curStartPositon === '右上角') {
      dstPart['startX'] = plankWidth - (startX + rectWidth) - tmpValueLeft
      dstPart['startY'] += tmpValue2
    }
  }
}

function rotate(part, source) {
  recordTransform(part, 'rotate', 90, source || 'rotate-internal')
  function crudeCopy(src) {
    // return jjFromUnit(jjSaveUnit(src));
    if (src) {
      return JSON.parse(JSON.stringify(src))
    } else {
      return src
    }
  }

  let expandRect = crudeCopy(part['expandRect'])
  var rect = crudeCopy(part['rect'])
  var oRect = crudeCopy(part['oRect'])
  var paths = crudeCopy(part['path'])
  var srcPath = crudeCopy(part['srcPath'])
  var unionPaths = crudeCopy(part['unionPath'])
  var oPaths = crudeCopy(part['oPath'])
  var holes = crudeCopy(part['holes'])
  var slots = crudeCopy(part['slots'])
  var handleSlopes = crudeCopy(part['handleSlopes'])
  var cutCurve = crudeCopy(part['cutCurve'])
  var cutCurveEx = crudeCopy(part['cutCurveEx'])
  var realCurve = crudeCopy(part['realCurve'])
  var realCurveEx = crudeCopy(part['realCurveEx'])
  var sholes = crudeCopy(part['sholes'])
  var sslots = crudeCopy(part['sslots'])
  var realRect = crudeCopy(part['realRect'])
  var edgeInfo = crudeCopy(part['edgeInfo'])
  var sholeInfo = crudeCopy(part['sholeInfo'])
  var sholeInfoF = crudeCopy(part['sholeInfoF'])
  var sslotInfo = crudeCopy(part['sslotInfo'])
  var sslotInfoF = crudeCopy(part['sslotInfoF'])
  var curveHoles = crudeCopy(part['curveHoles'])
  let millInfo = crudeCopy(part['millInfo']) ?? []
  var oriCurveHoles = crudeCopy(part['oriCurveHoles'])
  let lightEdgeInfo = part['lightEdgeInfo']
  let model_front_edge = part['model_front_edge']
  let doorOpenSide = part['doorOpenSide']
  let smoothEdge = part['smoothEdge']
  let lineSlots = part['lineSlots'] ?? []
  let frameDoorChildren = crudeCopy(part['frame_door_children'])
  var edgeTextureMap = crudeCopy(part['edge_texture_map'])
  let edgePreMillingInfo = part.edgePreMillingInfo
  let edgeArrowMap = crudeCopy(part['edgeArrowMap'])
  //TO DO 临时解决，重新设计
  const isPreLayout = store.state.ncSetting.isPreLayout
  // 指定刀直径
  let selectKnifeDiameter = isPreLayout ? cutKnifeRadius * 2 : 0

  var o = {
    x: rect.width / 2,
    y: rect.height / 2,
  }
  // var oo = Qt.point(oRect.width/2, oRect.height/2)
  var oo = {
    x: oRect.width / 2,
    y: oRect.height / 2,
  }
  // realRect 中心点（用于 oriPt1, oriPt2）
  var ro = {
    x: realRect.width / 2,
    y: realRect.height / 2,
  }

  // rect
  // rect = Qt.rect(0, 0, rect.height, rect.width);
  rect = {
    x: 0,
    y: 0,
    width: rect.height,
    height: rect.width,
  }
  if (expandRect) {
    expandRect = {
      x: 0,
      y: 0,
      width: expandRect.height,
      height: expandRect.width,
    }
  }
  // oRect = Qt.rect(0, 0, oRect.height, oRect.width);
  oRect = {
    x: 0,
    y: 0,
    width: oRect.height,
    height: oRect.width,
  }
  // realRect = Qt.rect(0, 0, realRect.height, realRect.width);
  realRect = {
    x: 0,
    y: 0,
    width: realRect.height,
    height: realRect.width,
  }

  // paths
  for (var i in paths) {
    var path = paths[i]
    for (var j in path) {
      var p = path[j]

      var x = p['x'] - o.x
      var y = p['y'] - o.y

      p['x'] = -y + o.y
      p['y'] = x + o.x
    }
  }
  if (srcPath) {
    for (var j in srcPath) {
      var p = srcPath[j]
      var x = p['x'] - o.x
      var y = p['y'] - o.y
      p['x'] = -y + o.y
      p['y'] = x + o.x
    }
  }

  // unionPaths
  for (var i in unionPaths) {
    var path = unionPaths[i]
    for (var j in path) {
      var p = path[j]

      var x = p['x'] - o.x
      var y = p['y'] - o.y

      p['x'] = -y + o.y
      p['y'] = x + o.x
    }
  }

  for (var i in oPaths) {
    var oPath = oPaths[i]
    for (var j in oPath) {
      var p = oPath[j]

      var x = p['x'] - oo.x
      var y = p['y'] - oo.y

      p['x'] = -y + oo.y
      p['y'] = x + oo.x
    }
  }

  for (var i in cutCurve) {
    var p = cutCurve[i]

    var x = p['x'] - o.x
    var y = p['y'] - o.y

    p['x'] = -y + o.y
    p['y'] = x + o.x
  }

  for (var i in cutCurveEx) {
    var path = cutCurveEx[i]
    for (var j in path) {
      var p = path[j]

      var x = p['x'] - o.x
      var y = p['y'] - o.y

      p['x'] = -y + o.y
      p['y'] = x + o.x
    }
  }

  //curveHoles
  for (var i in curveHoles) {
    var path = curveHoles[i]['path']
    const nativePath = curveHoles[i]['native_path'] ?? []
    for (var j in path) {
      var p = path[j]

      var x = p['x'] - o.x
      var y = p['y'] - o.y

      p['x'] = -y + o.y
      p['y'] = x + o.x
    }
    for (var j in nativePath) {
      var p = nativePath[j]

      var x = p['x'] - o.x
      var y = p['y'] - o.y

      p['x'] = -y + o.y
      p['y'] = x + o.x
    }
  }

  if (lineSlots) {
    lineSlots.forEach((lineSlot) => {
      const { path, oPath, oriPath, polygonArr = [] } = lineSlot
      for (var j in path) {
        var p = path[j]
        var x = p['x'] - o.x
        var y = p['y'] - o.y
        p['x'] = -y + o.y
        p['y'] = x + o.x
      }
      for (var j in oPath) {
        var p = oPath[j]
        var x = p['x'] - oo.x
        var y = p['y'] - oo.y
        p['x'] = -y + oo.y
        p['y'] = x + oo.x
      }
      // oriPath 使用 realRect 坐标系（ro）
      if (oriPath) {
        for (var j in oriPath) {
          var p = oriPath[j]
          var x = p['x'] - ro.x
          var y = p['y'] - ro.y
          p['x'] = -y + ro.y
          p['y'] = x + ro.x
        }
      }
      polygonArr.forEach((polygon) => {
        for (var j in polygon) {
          var p = polygon[j]
          var x = p['x'] - o.x
          var y = p['y'] - o.y
          p['x'] = -y + o.y
          p['y'] = x + o.x
        }
      })
    })
  }

  if (millInfo) {
    for (let i in millInfo) {
      const shape = millInfo[i]['shape']
      for (let j in shape) {
        const p = shape[j]
        const x = p['x'] - oo.x
        const y = p['y'] - oo.y
        p['x'] = -y + oo.y
        p['y'] = x + oo.x
      }
    }
  }

  //oriCurveHoles
  for (var i in oriCurveHoles) {
    var path = oriCurveHoles[i]['path']
    for (var j in path) {
      var p = path[j]

      var x = p['x'] - oo.x
      var y = p['y'] - oo.y

      p['x'] = -y + oo.y
      p['y'] = x + oo.x
    }
  }

  //realCurve
  var minx = -999999,
    miny,
    maxx,
    maxy
  for (var i in realCurve) {
    if (minx === -999999) {
      minx = maxx = realCurve[i].x
      miny = maxy = realCurve[i].y
    } else {
      minx = Math.min(minx, realCurve[i].x)
      miny = Math.min(miny, realCurve[i].y)
      maxx = Math.max(maxx, realCurve[i].x)
      maxy = Math.max(maxy, realCurve[i].y)
    }
  }
  var rw = maxx - minx
  var rh = maxy - miny
  var ro = {
    x: (maxx + minx) / 2,
    y: (maxy + miny) / 2,
  }

  for (var i in realCurve) {
    var p = realCurve[i]

    var x = p['x'] - oo.x
    var y = p['y'] - oo.y

    p['x'] = -y + oo.y
    p['y'] = x + oo.x
  }

  for (i in realCurveEx) {
    var ex = realCurveEx[i]
    for (j in ex) {
      p = ex[j]

      x = p['x'] - oo.x
      y = p['y'] - oo.y

      p['x'] = -y + oo.y
      p['y'] = x + oo.x
    }
  }

  // holes
  for (var h in holes) {
    var hole = holes[h]
    var center = hole['center']
    var ocenter = hole['ocenter']

    var x = center['x'] - o.x
    var y = center['y'] - o.y
    center['x'] = -y + o.y
    center['y'] = x + o.x

    x = ocenter['x'] - oo.x
    y = ocenter['y'] - oo.y
    ocenter['x'] = -y + oo.y
    ocenter['y'] = x + oo.x
    // 顺时针旋转
    const newHole = adjustHoleDirection(hole, 90 * 1)
    Object.assign(holes[h], newHole)
  }

  // slots
  for (var s in slots) {
    var slot = slots[s]
    var pt1 = slot['pt1']
    var pt2 = slot['pt2']
    var opt1 = slot['opt1']
    var opt2 = slot['opt2']
    var oriPt1 = slot['oriPt1']
    var oriPt2 = slot['oriPt2']

    var x1 = pt1['x'] - o.x
    var y1 = pt1['y'] - o.y
    var x2 = pt2['x'] - o.x
    var y2 = pt2['y'] - o.y

    pt1['x'] = -y1 + o.y
    pt1['y'] = x1 + o.x
    pt2['x'] = -y2 + o.y
    pt2['y'] = x2 + o.x

    // oriPt1, oriPt2 使用 realRect 坐标系（ro）
    if (oriPt1) {
      var ox1 = oriPt1['x'] - ro.x
      var oy1 = oriPt1['y'] - ro.y
      oriPt1['x'] = -oy1 + ro.y
      oriPt1['y'] = ox1 + ro.x
    }
    if (oriPt2) {
      var ox2 = oriPt2['x'] - ro.x
      var oy2 = oriPt2['y'] - ro.y
      oriPt2['x'] = -oy2 + ro.y
      oriPt2['y'] = ox2 + ro.x
    }

    x1 = opt1['x'] - oo.x
    y1 = opt1['y'] - oo.y
    x2 = opt2['x'] - oo.x
    y2 = opt2['y'] - oo.y

    opt1['x'] = -y1 + oo.y
    opt1['y'] = x1 + oo.x
    opt2['x'] = -y2 + oo.y
    opt2['y'] = x2 + oo.x
  }

  // handleSlopes
  for (var s in handleSlopes) {
    var slope = handleSlopes[s]
    var pt1 = slope['pt1']
    var pt2 = slope['pt2']
    var opt1 = slope['opt1']
    var opt2 = slope['opt2']

    var x1 = pt1['x'] - o.x
    var y1 = pt1['y'] - o.y
    var x2 = pt2['x'] - o.x
    var y2 = pt2['y'] - o.y

    pt1['x'] = -y1 + o.y
    pt1['y'] = x1 + o.x
    pt2['x'] = -y2 + o.y
    pt2['y'] = x2 + o.x

    x1 = opt1['x'] - oo.x
    y1 = opt1['y'] - oo.y
    x2 = opt2['x'] - oo.x
    y2 = opt2['y'] - oo.y

    opt1['x'] = -y1 + oo.y
    opt1['y'] = x1 + oo.x
    opt2['x'] = -y2 + oo.y
    opt2['y'] = x2 + oo.x
  }

  // sholes
  for (var k in sholes) {
    var shole = sholes[k]
    var side = shole['side']
    var ocenter = shole['ocenter']

    x = ocenter['x'] - oo.x
    y = ocenter['y'] - oo.y
    ocenter['x'] = -y + oo.y
    ocenter['y'] = x + oo.x

    side = parseInt(side) - 1
    if (side <= 0) {
      side = 4
    }

    shole['side'] = side
  }

  // sslots
  for (var j in sslots) {
    var sslot = sslots[j]
    var side = sslot['side']
    var opt1 = sslot['opt1']
    var opt2 = sslot['opt2']

    x1 = opt1['x'] - oo.x
    y1 = opt1['y'] - oo.y
    x2 = opt2['x'] - oo.x
    y2 = opt2['y'] - oo.y

    opt1['x'] = -y1 + oo.y
    opt1['y'] = x1 + oo.x
    opt2['x'] = -y2 + oo.y
    opt2['y'] = x2 + oo.x

    side = parseInt(side) - 1
    if (side <= 0) {
      side = 4
    }

    sslot['side'] = side
  }

  // sholeInfo
  sholeInfo = generatorSideHoleSlot([
    ...sholes,
    ...holes.filter((hole) => isSideMachineHole(hole) && hole.side == 1),
  ])
  sholeInfoF = generatorSideHoleSlot(
    holes.filter((hole) => isSideMachineHole(hole) && hole.side == -1),
    'upDownFlip'
  )
  // 开启 侧孔机加工牛角拉手 需将牛角拉手放到侧槽信息里面
  let sideMillInfo = millInfo.filter((mill) => isSideMachineMillInfo(mill))
  sslotInfo = generatorSideHoleSlot(
    [
      ...sslots,
      ...slots.filter((slot) => isSideMachineSlot(slot) && slot.side == 1),
      ...sideMillInfo.filter((mill) => mill.side == '1'),
    ],
    '',
    part
  )
  sslotInfoF = generatorSideHoleSlot(
    slots.filter((slot) => isSideMachineSlot(slot) && slot.side == -1),
    'upDownFlip',
    part
  )

  // edgeInfo
  var left = edgeInfo.substring(
    edgeInfo.indexOf('←') + 1,
    edgeInfo.indexOf('↓')
  )
  var bottom = edgeInfo.substring(
    edgeInfo.indexOf('↓') + 1,
    edgeInfo.indexOf('→')
  )
  var right = edgeInfo.substring(
    edgeInfo.indexOf('→') + 1,
    edgeInfo.indexOf('↑')
  )
  var top = edgeInfo.substring(edgeInfo.indexOf('↑') + 1)
  edgeInfo = '←' + bottom + '↓' + right + '→' + top + '↑' + left // 顺时针90

  // edge_texture_map - 按照与 edgeInfo 相同的旋转逻辑
  if (edgeTextureMap) {
    // 确保数组有4个元素，对应左、下、右、上
    var leftTexture = edgeTextureMap[1] || ''
    var bottomTexture = edgeTextureMap[2] || ''
    var rightTexture = edgeTextureMap[3] || ''
    var topTexture = edgeTextureMap[4] || ''

    // 按照顺时针90度旋转：左→上，下→左，右→下，上→右
    edgeTextureMap[1] = bottomTexture // 新的左 = 原来的下
    edgeTextureMap[2] = rightTexture // 新的下 = 原来的右
    edgeTextureMap[3] = topTexture // 新的右 = 原来的上
    edgeTextureMap[4] = leftTexture // 新的上 = 原来的左

    // appliedSides 按照与 edgeInfo 相同的旋转逻辑
    if (edgePreMillingInfo?.appliedSides) {
      const { left, right, top, bottom } = edgePreMillingInfo.appliedSides
      edgePreMillingInfo.appliedSides = {
        left: bottom,
        right: top,
        top: left,
        bottom: right,
      }
    }
  }
  // edgeArrowMap - 按照与 edgeInfo 相同的旋转逻辑
  if (edgeArrowMap) {
    // 左、下、右、上
    let leftName = edgeArrowMap[0]
    let bottomName = edgeArrowMap[1]
    let rightName = edgeArrowMap[2]
    let topName = edgeArrowMap[3]

    edgeArrowMap[0] = bottomName
    edgeArrowMap[1] = rightName
    edgeArrowMap[2] = topName
    edgeArrowMap[3] = leftName
  }
  lightEdgeInfo = dealEdgeInfoChange(lightEdgeInfo, 'rotate90')
  model_front_edge = dealFormerEdgeChange(
    model_front_edge,
    'rotate90',
    'former'
  )
  doorOpenSide = dealFormerEdgeChange(doorOpenSide, 'rotate90', 'doorOpenSide')
  smoothEdge = dealFormerEdgeChange(smoothEdge, 'rotate90', 'doorOpenSide')
  var obj = {}

  if (paths) {
    obj['path'] = paths
  }
  if (srcPath) {
    obj['srcPath'] = srcPath
  }
  if (unionPaths) {
    obj['unionPath'] = unionPaths
  }
  if (oPaths) {
    obj['oPath'] = oPaths
  }
  obj['expandRect'] = expandRect
  obj['rect'] = rect
  obj['oRect'] = oRect
  obj['holes'] = holes
  obj['slots'] = slots
  obj['sholes'] = sholes
  obj['sslots'] = sslots
  obj['realRect'] = realRect
  obj['edgeInfo'] = edgeInfo
  obj['edge_texture_map'] = edgeTextureMap
  obj['sholeInfo'] = sholeInfo
  obj['sholeInfoF'] = sholeInfoF
  obj['sslotInfo'] = sslotInfo
  obj['sslotInfoF'] = sslotInfoF
  obj['cutCurve'] = cutCurve
  obj['cutCurveEx'] = cutCurveEx
  obj['realCurve'] = realCurve
  obj['realCurveEx'] = realCurveEx
  obj['curveHoles'] = curveHoles
  obj['millInfo'] = millInfo
  obj['oriCurveHoles'] = oriCurveHoles
  obj['lightEdgeInfo'] = lightEdgeInfo
  obj['model_front_edge'] = model_front_edge
  obj['doorOpenSide'] = doorOpenSide
  obj['handleSlopes'] = handleSlopes
  obj['smoothEdge'] = smoothEdge
  obj['lineSlots'] = lineSlots
  obj['edgePreMillingInfo'] = edgePreMillingInfo
  obj['edgeArrowMap'] = edgeArrowMap
  // 合并骨骼门旋转后 原始的 5 块单板也需要旋转
  if (judgeIsMergeFrameDoor(part)) {
    obj['frame_door_children'] = frameDoorChildren.map((child) => rotate(child))
  }
  return obj
}

// 板件旋转180
export function rotate180Part(part, source, options = {}) {
  if (!part) {
    return
  }
  if (!options.skipRecord) {
    recordTransform(part, 'rotate', 180, source || 'rotate180Part')
  }
  let expandRect = part['expandRect']
  var rect = part['rect']
  var oRect = part['oRect']
  var startX = part['startX']
  var startY = part['startY']
  var paths = part['path']
  var srcPath = part['srcPath']
  var unionPaths = part['unionPath']
  var oPaths = part['oPath']
  var cutCurve = part['cutCurve']
  var cutCurveEx = part['cutCurveEx']
  var realCurve = part['realCurve']
  var realCurveEx = part['realCurveEx']
  var holes = part['holes']
  var slots = part['slots']
  var lineSlots = part['lineSlots'] ?? []
  var handleSlopes = part['handleSlopes']
  var sholes = part['sholes']
  var sslots = part['sslots']
  var realRect = part['realRect']
  var edgeInfo = part['edgeInfo']
  var sholeInfo = part['sholeInfo']
  var sholeInfoF = part['sholeInfoF']
  var sslotInfo = part['sslotInfo']
  var sslotInfoF = part['sslotInfoF']
  var curveHoles = part['curveHoles']
  var millInfo = part['millInfo'] ?? []
  var oriCurveHoles = part['oriCurveHoles']
  let lightEdgeInfo = part['lightEdgeInfo']
  let model_front_edge = part['model_front_edge']
  let doorOpenSide = part['doorOpenSide']
  let smoothEdge = part['smoothEdge']
  var edgeTextureMap = part['edge_texture_map']
  var frameDoorChildren = part['frame_door_children']
  let edgePreMillingInfo = part['edgePreMillingInfo']
  let edgeArrowMap = part['edgeArrowMap']
  const pathEdge = part['pathEdge'] ?? []
  if (part['finalExtendDisMap']) {
    part['finalExtendDisMap'] = getRotateObject(part['finalExtendDisMap'], 180)
  }

  // paths
  for (var i in paths) {
    var path = paths[i]
    for (var j in path) {
      path[j].x = rect.width - path[j].x
      path[j].y = rect.height - path[j].y
    }
  }

  if (srcPath) {
    for (var j in srcPath) {
      srcPath[j].x = rect.width - srcPath[j].x
      srcPath[j].y = rect.height - srcPath[j].y
    }
  }

  // 拉线槽处理
  if (lineSlots) {
    for (let idx = 0; idx < lineSlots.length; idx++) {
      const lineSlot = lineSlots[idx]
      const { path, oPath, oriPath, polygonArr = [] } = lineSlot
      for (var i in path) {
        path[i].x = rect.width - path[i].x
        path[i].y = rect.height - path[i].y
      }
      for (var i in oPath) {
        oPath[i].x = oRect.width - oPath[i].x
        oPath[i].y = oRect.height - oPath[i].y
      }
      // oriPath 使用 realRect 坐标系
      if (oriPath) {
        for (var i in oriPath) {
          oriPath[i].x = realRect.width - oriPath[i].x
          oriPath[i].y = realRect.height - oriPath[i].y
        }
      }
      polygonArr.forEach((polygon) => {
        for (var i in polygon) {
          polygon[i].x = rect.width - polygon[i].x
          polygon[i].y = rect.height - polygon[i].y
        }
      })
    }
  }

  // unionPaths
  for (var i in unionPaths) {
    var path = unionPaths[i]
    for (var j in path) {
      path[j].x = rect.width - path[j].x
      path[j].y = rect.height - path[j].y
    }
  }

  // oPaths
  for (var i in oPaths) {
    var path = oPaths[i]
    for (var j in path) {
      path[j].x = oRect.width - path[j].x
      path[j].y = oRect.height - path[j].y
    }
  }

  for (var i in curveHoles) {
    var path = curveHoles[i]['path']
    const nativePath = curveHoles[i]['native_path']
    for (var j in path) {
      var p = path[j]
      p.x = rect.width - p.x
      p.y = rect.height - p.y
    }
    for (var j in nativePath) {
      var p = nativePath[j]
      p.x = rect.width - p.x
      p.y = rect.height - p.y
    }
  }
  if (millInfo) {
    for (let i in millInfo) {
      const shape = millInfo[i]['shape']
      for (let j in shape) {
        const p = shape[j]
        p.x = oRect.width - p.x
        p.y = oRect.height - p.y
      }
    }
  }

  for (var i in oriCurveHoles) {
    var path = oriCurveHoles[i]['path']
    for (var j in path) {
      var p = path[j]
      p.x = oRect.width - p.x
      p.y = oRect.height - p.y
    }
  }

  // cutCurve
  for (var i in cutCurve) {
    var p = cutCurve[i]
    p.x = rect.width - p['x']
    p.y = rect.height - p['y']
  }

  // cutCurveEx
  for (var i in cutCurveEx) {
    path = cutCurveEx[i]
    for (var j in path) {
      path[j].x = rect.width - path[j].x
      path[j].y = rect.height - path[j].y
    }
  }

  // realCurve
  for (var i in realCurve) {
    var p = realCurve[i]

    p['x'] = oRect.width - p['x']
    p['y'] = oRect.height - p['y']
  }

  // realCurveEx
  for (var i in realCurveEx) {
    var path = realCurveEx[i]
    for (var j in path) {
      path[j].x = oRect.width - path[j].x
      path[j].y = oRect.height - path[j].y
    }
  }

  // holes
  for (var h in holes) {
    var center = holes[h].center
    center.x = rect.width - center.x
    center.y = rect.height - center.y
    var ocenter = holes[h].ocenter
    ocenter.x = oRect.width - ocenter.x
    ocenter.y = oRect.height - ocenter.y
    const newHole = adjustHoleDirection(holes[h], 180 * 1)
    Object.assign(holes[h], newHole)
  }

  // slots
  for (var s in slots) {
    var slot = slots[s]
    var pt1 = slot['pt1']
    var pt2 = slot['pt2']
    var oriPt1 = slot['oriPt1']
    var oriPt2 = slot['oriPt2']

    pt1.x = rect.width - pt1.x
    pt1.y = rect.height - pt1.y

    pt2.x = rect.width - pt2.x
    pt2.y = rect.height - pt2.y

    // oriPt1, oriPt2 使用 realRect 坐标系
    if (oriPt1) {
      oriPt1.x = realRect.width - oriPt1.x
      oriPt1.y = realRect.height - oriPt1.y
    }
    if (oriPt2) {
      oriPt2.x = realRect.width - oriPt2.x
      oriPt2.y = realRect.height - oriPt2.y
    }

    var opt1 = slot['opt1']
    var opt2 = slot['opt2']

    opt1.x = oRect.width - opt1.x
    opt1.y = oRect.height - opt1.y

    opt2.x = oRect.width - opt2.x
    opt2.y = oRect.height - opt2.y
  }

  // handleSlopes
  for (var s in handleSlopes) {
    var slope = handleSlopes[s]
    var pt1 = slope['pt1']
    var pt2 = slope['pt2']

    pt1.x = rect.width - pt1.x
    pt1.y = rect.height - pt1.y

    pt2.x = rect.width - pt2.x
    pt2.y = rect.height - pt2.y

    var opt1 = slope['opt1']
    var opt2 = slope['opt2']

    opt1.x = oRect.width - opt1.x
    opt1.y = oRect.height - opt1.y

    opt2.x = oRect.width - opt2.x
    opt2.y = oRect.height - opt2.y
  }

  // sholes
  for (var k in sholes) {
    var shole = sholes[k]
    var side = shole['side']

    var ocenter = sholes[k].ocenter
    ocenter.x = oRect.width - ocenter.x
    ocenter.y = oRect.height - ocenter.y

    if (side == 2) {
      side = 4
    } else if (side == 1) {
      side = 3
    } else {
      side = parseInt(side) - 2
    }

    shole['side'] = side
  }

  // sslots
  for (var j in sslots) {
    var sslot = sslots[j]
    var side = sslot['side']

    if (side == 2) {
      side = 4
    } else if (side == 1) {
      side = 3
    } else {
      side = parseInt(side) - 2
    }

    sslot['side'] = side

    var opt1 = sslot['opt1']
    var opt2 = sslot['opt2']

    opt1.x = oRect.width - opt1['x']
    opt1.y = oRect.height - opt1['y']
    opt2.x = oRect.width - opt2['x']
    opt2.y = oRect.height - opt2['y']
  }

  sholeInfo = generatorSideHoleSlot([
    ...sholes,
    ...holes.filter((hole) => isSideMachineHole(hole) && hole.side == 1),
  ])
  sholeInfoF = generatorSideHoleSlot(
    holes.filter((hole) => isSideMachineHole(hole) && hole.side == -1),
    'upDownFlip'
  )
  // 开启 侧孔机加工牛角拉手 需将牛角拉手放到侧槽信息里面
  let sideMillInfo = millInfo.filter((mill) => isSideMachineMillInfo(mill))
  sslotInfo = generatorSideHoleSlot(
    [
      ...sslots,
      ...slots.filter((slot) => isSideMachineSlot(slot) && slot.side == 1),
      ...sideMillInfo?.filter((mill) => mill.side == '1'),
    ],
    '',
    part
  )
  sslotInfoF = generatorSideHoleSlot(
    slots.filter((slot) => isSideMachineSlot(slot) && slot.side == -1),
    'upDownFlip',
    part
  )

  // edgeInfo
  var left = edgeInfo.substring(
    edgeInfo.indexOf('←') + 1,
    edgeInfo.indexOf('↓')
  )
  var bottom = edgeInfo.substring(
    edgeInfo.indexOf('↓') + 1,
    edgeInfo.indexOf('→')
  )
  var right = edgeInfo.substring(
    edgeInfo.indexOf('→') + 1,
    edgeInfo.indexOf('↑')
  )
  var top = edgeInfo.substring(edgeInfo.indexOf('↑') + 1)
  edgeInfo = '←' + right + '↓' + top + '→' + left + '↑' + bottom // 顺时针转了180

  // edge_texture_map - 按照与 edgeInfo 相同的180度旋转逻辑
  if (edgeTextureMap) {
    // 确保数组有4个元素，对应左、下、右、上
    var leftTexture = edgeTextureMap[1] || ''
    var bottomTexture = edgeTextureMap[2] || ''
    var rightTexture = edgeTextureMap[3] || ''
    var topTexture = edgeTextureMap[4] || ''

    // 按照顺时针180度旋转：左→右，下→上，右→左，上→下
    edgeTextureMap[1] = rightTexture // 新的左 = 原来的右
    edgeTextureMap[2] = topTexture // 新的下 = 原来的上
    edgeTextureMap[3] = leftTexture // 新的右 = 原来的左
    edgeTextureMap[4] = bottomTexture // 新的上 = 原来的下
  }
  // edgeArrowMap - 按照与 edgeInfo 相同的180度旋转逻辑
  // edgeInfo: ←right ↓top →left ↑bottom
  if (edgeArrowMap) {
    // 左、下、右、上
    let leftName = edgeArrowMap[0]
    let bottomName = edgeArrowMap[1]
    let rightName = edgeArrowMap[2]
    let topName = edgeArrowMap[3]

    edgeArrowMap[0] = rightName // 新的左 = 原来的右
    edgeArrowMap[1] = topName // 新的下 = 原来的上
    edgeArrowMap[2] = leftName // 新的右 = 原来的左
    edgeArrowMap[3] = bottomName // 新的上 = 原来的下
  }
  // appliedSides 按照与 edgeInfo 相同的旋转逻辑
  if (edgePreMillingInfo?.appliedSides) {
    const { left, right, top, bottom } = edgePreMillingInfo.appliedSides
    edgePreMillingInfo.appliedSides = {
      left: right,
      right: left,
      top: bottom,
      bottom: top,
    }
  }

  lightEdgeInfo = dealEdgeInfoChange(lightEdgeInfo, 'rotate180')
  model_front_edge = dealFormerEdgeChange(
    model_front_edge,
    'rotate180',
    'former'
  )
  smoothEdge = dealFormerEdgeChange(smoothEdge, 'rotate180', 'doorOpenSide')
  doorOpenSide = dealFormerEdgeChange(doorOpenSide, 'rotate180', 'doorOpenSide')

  for (let idx = 0; idx < pathEdge.length; idx++) {
    const edge = pathEdge[idx]
    switch (edge) {
      case 'left':
        pathEdge[idx] = 'right'
        break
      case 'right':
        pathEdge[idx] = 'left'
        break
      case 'top':
        pathEdge[idx] = 'bottom'
        break
      case 'bottom':
        pathEdge[idx] = 'top'
        break
    }
  }
  part['pathEdge'] = pathEdge

  part['expandRect'] = expandRect
  part['rect'] = rect
  part['oRect'] = oRect
  part['startX'] = startX
  part['startY'] = startY
  part['path'] = paths
  part['srcPath'] = srcPath
  part['unionPath'] = unionPaths
  part['oPath'] = oPaths
  part['cutCurve'] = cutCurve
  part['cutCurveEx'] = cutCurveEx
  part['realCurve'] = realCurve
  part['realCurveEx'] = realCurveEx
  part['holes'] = holes
  part['slots'] = slots
  part['sholes'] = sholes
  part['sslots'] = sslots
  part['realRect'] = realRect
  part['edgeInfo'] = edgeInfo
  part['edge_texture_map'] = edgeTextureMap
  part['sholeInfo'] = sholeInfo
  part['sholeInfoF'] = sholeInfoF
  part['sslotInfoF'] = sslotInfoF
  part['sslotInfo'] = sslotInfo
  part['curveHoles'] = curveHoles
  part['millInfo'] = millInfo
  part['oriCurveHoles'] = oriCurveHoles
  part['lightEdgeInfo'] = lightEdgeInfo
  part['model_front_edge'] = model_front_edge
  part['smoothEdge'] = smoothEdge
  part['doorOpenSide'] = doorOpenSide
  part['handleSlopes'] = handleSlopes
  part['lineSlots'] = lineSlots
  part['edgeArrowMap'] = edgeArrowMap
  // 合并骨骼门旋转后 原始的 5 块单板也需要旋转
  if (judgeIsMergeFrameDoor(part)) {
    part['frame_door_children'] = frameDoorChildren.map((child) =>
      rotate180Part(JSON.parse(JSON.stringify(child)))
    )
  }
  return part
}

// 旋转板件

export function rotatePart(part, source) {
  if (!part) {
    return
  }

  recordTransform(part, 'rotate', 90, source || 'rotatePart')

  var rect = part['rect']
  var oRect = part['oRect']
  var startX = part['startX']
  var startY = part['startY']
  var paths = part['path']
  var srcPath = part['srcPath']
  var unionPaths = part['unionPath']
  var oPaths = part['oPath']
  var cutCurve = part['cutCurve']
  var cutCurveEx = part['cutCurveEx']
  var realCurve = part['realCurve']
  var realCurveEx = part['realCurveEx']
  var holes = part['holes']
  var slots = part['slots']
  var handleSlopes = part['handleSlopes']
  var sholes = part['sholes']
  var sslots = part['sslots']
  var realRect = part['realRect']
  var edgeInfo = part['edgeInfo']
  var sholeInfo = part['sholeInfo']
  var sholeInfoF = part['sholeInfoF']
  var sslotInfoF = part['sslotInfoF']
  var sslotInfo = part['sslotInfo']
  var curveHoles = part['curveHoles']
  var millInfo = part['millInfo'] ?? []
  var oriCurveHoles = part['oriCurveHoles']
  let lightEdgeInfo = part['lightEdgeInfo']
  let model_front_edge = part['model_front_edge']
  let doorOpenSide = part['doorOpenSide']
  let smoothEdge = part['smoothEdge']
  let expandRect = part['expandRect']
  let lineSlots = part['lineSlots'] ?? []
  var edgeTextureMap = part['edge_texture_map']
  let edgePreMillingInfo = part['edgePreMillingInfo']
  let oldSize = part['oldSize']
  const pathEdge = part['pathEdge'] ?? []
  let edgeArrowMap = part['edgeArrowMap']
  // 顺时针旋转

  // 板件中心点
  // var o = Qt.point(rect.width / 2, rect.height / 2);
  var o = {
    x: rect.width / 2,
    y: rect.height / 2,
  }

  // var oo = Qt.point(oRect.width / 2, oRect.height / 2);
  var oo = {
    x: oRect.width / 2,
    y: oRect.height / 2,
  }
  // realRect 中心点（用于 oriPt1, oriPt2）
  var ro = {
    x: realRect.width / 2,
    y: realRect.height / 2,
  }

  // startX\startY
  startX = startX + o.x - rect.height / 2
  startY = startY + o.y - rect.width / 2
  // rect
  // rect = Qt.rect(0, 0, rect.height, rect.width);
  rect = {
    x: 0,
    y: 0,
    width: rect.height,
    height: rect.width,
  }

  if (expandRect) {
    expandRect = {
      x: 0,
      y: 0,
      width: expandRect.height,
      height: expandRect.width,
    }
  }

  oRect = {
    x: 0,
    y: 0,
    width: oRect.height,
    height: oRect.width,
  }

  if (oldSize) {
    oldSize = {
      width: oldSize.height,
      height: oldSize.width,
    }
  }

  // realRect = Qt.rect(0, 0, realRect.height, realRect.width);
  realRect = {
    x: 0,
    y: 0,
    width: realRect.height,
    height: realRect.width,
  }

  // paths
  for (var i in paths) {
    var path = paths[i]
    for (var j in path) {
      const p = window.$copy(path[j])
      var x = p['x'] - o.x
      var y = p['y'] - o.y

      p['x'] = -y + o.y
      p['y'] = x + o.x
      path[j] = p
    }
  }
  if (srcPath) {
    for (var j in srcPath) {
      const p = window.$copy(srcPath[j])
      var x = p['x'] - o.x
      var y = p['y'] - o.y
      p['x'] = -y + o.y
      p['y'] = x + o.x
      srcPath[j] = p
    }
  }

  // unionPaths
  for (var i in unionPaths) {
    var path = unionPaths[i]
    for (var j in path) {
      var p = path[j]
      var x = p['x'] - o.x
      var y = p['y'] - o.y

      p['x'] = -y + o.y
      p['y'] = x + o.x
    }
  }

  // oPaths
  for (var i in oPaths) {
    var path = oPaths[i]
    for (var j in path) {
      var p = path[j]
      var x = p['x'] - oo.x
      var y = p['y'] - oo.y

      p['x'] = -y + oo.y
      p['y'] = x + oo.x
    }
  }

  for (var i in cutCurve) {
    p = cutCurve[i]
    x = p['x'] - o.x
    y = p['y'] - o.y

    p['x'] = -y + o.y
    p['y'] = x + o.x
  }

  for (var i in cutCurveEx) {
    path = cutCurveEx[i]
    for (var j in path) {
      p = path[j]
      x = p['x'] - o.x
      y = p['y'] - o.y
      p['x'] = -y + o.y
      p['y'] = x + o.x
    }
  }
  for (var i in curveHoles) {
    path = curveHoles[i]
    const nativePath = curveHoles[i]['native_path'] ?? []
    for (var j in path.path) {
      p = path.path[j]
      x = p['x'] - o.x
      y = p['y'] - o.y
      p['x'] = -y + o.y
      p['y'] = x + o.x
    }
    for (var j in nativePath) {
      p = nativePath[j]
      x = p['x'] - o.x
      y = p['y'] - o.y
      p['x'] = -y + o.y
      p['y'] = x + o.x
    }
  }
  if (millInfo) {
    for (let i in millInfo) {
      const { shape } = millInfo[i]
      for (let j in shape) {
        p = shape[j]
        x = p['x'] - oo.x
        y = p['y'] - oo.y
        p['x'] = -y + oo.y
        p['y'] = x + oo.x
      }
    }
  }

  for (var i in oriCurveHoles) {
    path = oriCurveHoles[i]
    for (var j in path.path) {
      p = path.path[j]
      x = p['x'] - oo.x
      y = p['y'] - oo.y
      p['x'] = -y + oo.y
      p['y'] = x + oo.x
    }
  }

  for (var i in realCurve) {
    p = realCurve[i]

    x = p['x'] - oo.x
    y = p['y'] - oo.y

    p['x'] = -y + oo.y
    p['y'] = x + oo.x
  }

  for (var i in realCurveEx) {
    path = realCurveEx[i]
    for (var j in path) {
      p = path[j]

      x = p['x'] - oo.x
      y = p['y'] - oo.y

      p['x'] = -y + oo.y
      p['y'] = x + oo.x
    }
  }

  // holes
  for (var h in holes) {
    var hole = holes[h]
    var center = hole['center']
    var ocenter = hole['ocenter']

    var x = center['x'] - o.x
    var y = center['y'] - o.y
    var xx = ocenter['x'] - oo.x
    var yy = ocenter['y'] - oo.y

    center['x'] = -y + o.y
    center['y'] = x + o.x

    ocenter['x'] = -yy + oo.y
    ocenter['y'] = xx + oo.x
    const newHole = adjustHoleDirection(hole, 90 * 1)
    Object.assign(holes[h], newHole)
  }
  // lineSlots
  for (let idx = 0; idx < lineSlots.length; idx++) {
    const lineSlot = lineSlots[idx]
    const { path, oPath, oriPath, polygonArr = [] } = lineSlot
    for (var j in path) {
      var p = path[j]
      var x = p['x'] - o.x
      var y = p['y'] - o.y

      p['x'] = -y + o.y
      p['y'] = x + o.x
    }
    for (var j in oPath) {
      var p = oPath[j]
      var x = p['x'] - oo.x
      var y = p['y'] - oo.y

      p['x'] = -y + oo.y
      p['y'] = x + oo.x
    }
    // oriPath 使用 realRect 坐标系（ro）
    if (oriPath) {
      for (var j in oriPath) {
        var p = oriPath[j]
        var x = p['x'] - ro.x
        var y = p['y'] - ro.y

        p['x'] = -y + ro.y
        p['y'] = x + ro.x
      }
    }
    polygonArr.forEach((polygon) => {
      for (var j in polygon) {
        var p = polygon[j]
        var x = p['x'] - o.x
        var y = p['y'] - o.y

        p['x'] = -y + o.y
        p['y'] = x + o.x
      }
    })
  }

  // slots
  for (var s in slots) {
    var slot = slots[s]
    var pt1 = slot['pt1']
    var pt2 = slot['pt2']
    var opt1 = slot['opt1']
    var opt2 = slot['opt2']
    var oriPt1 = slot['oriPt1']
    var oriPt2 = slot['oriPt2']

    var x1 = pt1['x'] - o.x
    var y1 = pt1['y'] - o.y
    var x2 = pt2['x'] - o.x
    var y2 = pt2['y'] - o.y

    var xx1 = opt1['x'] - oo.x
    var yy1 = opt1['y'] - oo.y
    var xx2 = opt2['x'] - oo.x
    var yy2 = opt2['y'] - oo.y

    pt1['x'] = -y1 + o.y
    pt1['y'] = x1 + o.x
    pt2['x'] = -y2 + o.y
    pt2['y'] = x2 + o.x

    // oriPt1, oriPt2 使用 realRect 坐标系（ro）
    if (oriPt1) {
      var ox1 = oriPt1['x'] - ro.x
      var oy1 = oriPt1['y'] - ro.y
      oriPt1['x'] = -oy1 + ro.y
      oriPt1['y'] = ox1 + ro.x
    }
    if (oriPt2) {
      var ox2 = oriPt2['x'] - ro.x
      var oy2 = oriPt2['y'] - ro.y
      oriPt2['x'] = -oy2 + ro.y
      oriPt2['y'] = ox2 + ro.x
    }

    opt1['x'] = -yy1 + oo.y
    opt1['y'] = xx1 + oo.x
    opt2['x'] = -yy2 + oo.y
    opt2['y'] = xx2 + oo.x
  }

  // handleSlopes
  for (var s in handleSlopes) {
    var slope = handleSlopes[s]
    var pt1 = slope['pt1']
    var pt2 = slope['pt2']
    var opt1 = slope['opt1']
    var opt2 = slope['opt2']

    var x1 = pt1['x'] - o.x
    var y1 = pt1['y'] - o.y
    var x2 = pt2['x'] - o.x
    var y2 = pt2['y'] - o.y

    var xx1 = opt1['x'] - oo.x
    var yy1 = opt1['y'] - oo.y
    var xx2 = opt2['x'] - oo.x
    var yy2 = opt2['y'] - oo.y

    pt1['x'] = -y1 + o.y
    pt1['y'] = x1 + o.x
    pt2['x'] = -y2 + o.y
    pt2['y'] = x2 + o.x

    opt1['x'] = -yy1 + oo.y
    opt1['y'] = xx1 + oo.x
    opt2['x'] = -yy2 + oo.y
    opt2['y'] = xx2 + oo.x
  }

  // sholes
  for (var k in sholes) {
    var shole = sholes[k]
    var side = shole['side']
    var ocenter = shole['ocenter']
    x = ocenter['x'] - oo.x
    y = ocenter['y'] - oo.y
    ocenter['x'] = -y + oo.y
    ocenter['y'] = x + oo.x

    if (ncSettings.xyReverse) {
      side = parseInt(side) - 1
    } else {
      side = parseInt(side) - 1
    }
    if (side <= 0) {
      side = 4
    }
    if (side >= 5) {
      side = 1
    }

    shole['side'] = side
  }

  // sslots
  for (var j in sslots) {
    var sslot = sslots[j]
    var side = sslot['side']
    var opt1 = sslot['opt1']
    var opt2 = sslot['opt2']

    x1 = opt1['x'] - oo.x
    y1 = opt1['y'] - oo.y
    x2 = opt2['x'] - oo.x
    y2 = opt2['y'] - oo.y

    opt1['x'] = -y1 + oo.y
    opt1['y'] = x1 + oo.x
    opt2['x'] = -y2 + oo.y
    opt2['y'] = x2 + oo.x

    if (ncSettings.xyReverse) {
      side = parseInt(side) - 1
    } else {
      side = parseInt(side) - 1
    }
    if (side <= 0) {
      side = 4
    }
    if (side >= 5) {
      side = 1
    }

    sslot['side'] = side
  }
  sholeInfo = generatorSideHoleSlot([
    ...sholes,
    ...holes.filter((hole) => isSideMachineHole(hole) && hole.side == 1),
  ])
  sholeInfoF = generatorSideHoleSlot(
    holes.filter((hole) => isSideMachineHole(hole) && hole.side == -1),
    'upDownFlip'
  )
  // 开启 侧孔机加工牛角拉手 需将牛角拉手放到侧槽信息里面
  let sideMillInfo = millInfo.filter((mill) => isSideMachineMillInfo(mill))
  sslotInfo = generatorSideHoleSlot(
    [
      ...sslots,
      ...slots.filter((slot) => isSideMachineSlot(slot) && slot.side == 1),
      ...sideMillInfo.filter((mill) => mill.side == '1'),
    ],
    '',
    part
  )
  sslotInfoF = generatorSideHoleSlot(
    slots.filter((slot) => isSideMachineSlot(slot) && slot.side == -1),
    'upDownFlip',
    part
  )

  // edgeInfo
  var left = edgeInfo.substring(
    edgeInfo.indexOf('←') + 1,
    edgeInfo.indexOf('↓')
  )
  var bottom = edgeInfo.substring(
    edgeInfo.indexOf('↓') + 1,
    edgeInfo.indexOf('→')
  )
  var right = edgeInfo.substring(
    edgeInfo.indexOf('→') + 1,
    edgeInfo.indexOf('↑')
  )
  var top = edgeInfo.substring(edgeInfo.indexOf('↑') + 1)
  edgeInfo = '←' + bottom + '↓' + right + '→' + top + '↑' + left

  // edge_texture_map - 按照与 edgeInfo 相同的旋转逻辑
  if (edgeTextureMap) {
    // 确保数组有4个元素，对应左、下、右、上

    var leftTexture = edgeTextureMap[1] || ''
    var bottomTexture = edgeTextureMap[2] || ''
    var rightTexture = edgeTextureMap[3] || ''
    var topTexture = edgeTextureMap[4] || ''

    // 按照顺时针90度旋转：左→上，下→左，右→下，上→右
    edgeTextureMap[1] = bottomTexture // 新的左 = 原来的下
    edgeTextureMap[2] = rightTexture // 新的下 = 原来的右
    edgeTextureMap[3] = topTexture // 新的右 = 原来的上
    edgeTextureMap[4] = leftTexture // 新的上 = 原来的左
  }
  // edgeArrowMap - 按照与 edgeInfo 相同的旋转逻辑
  if (edgeArrowMap) {
    // 左、下、右、上
    let leftName = edgeArrowMap[0]
    let bottomName = edgeArrowMap[1]
    let rightName = edgeArrowMap[2]
    let topName = edgeArrowMap[3]

    edgeArrowMap[0] = bottomName
    edgeArrowMap[1] = rightName
    edgeArrowMap[2] = topName
    edgeArrowMap[3] = leftName
  }
  // appliedSides 按照与 edgeInfo 相同的旋转逻辑
  if (edgePreMillingInfo?.appliedSides) {
    const { left, right, top, bottom } = edgePreMillingInfo.appliedSides
    edgePreMillingInfo.appliedSides = {
      left: bottom,
      right: top,
      top: left,
      bottom: right,
    }
  }
  lightEdgeInfo = dealEdgeInfoChange(lightEdgeInfo, 'rotate90')
  model_front_edge = dealFormerEdgeChange(
    model_front_edge,
    'rotate90',
    'former'
  )
  smoothEdge = dealFormerEdgeChange(smoothEdge, 'rotate90', 'doorOpenSide')
  doorOpenSide = dealFormerEdgeChange(doorOpenSide, 'rotate90', 'doorOpenSide')

  for (let idx = 0; idx < pathEdge.length; idx++) {
    const edge = pathEdge[idx]
    switch (edge) {
      case 'left':
        pathEdge[idx] = 'top'
        break
      case 'right':
        pathEdge[idx] = 'bottom'
        break
      case 'top':
        pathEdge[idx] = 'right'
        break
      case 'bottom':
        pathEdge[idx] = 'left'
        break
    }
  }
  part['pathEdge'] = pathEdge
  part['rect'] = rect
  part['oRect'] = oRect
  part['oldSize'] = oldSize
  part['startX'] = startX
  part['startY'] = startY
  part['path'] = paths
  part['srcPath'] = srcPath
  part['unionPath'] = unionPaths
  part['oPath'] = oPaths
  part['cutCurve'] = cutCurve
  part['cutCurveEx'] = cutCurveEx
  part['realCurve'] = realCurve
  part['realCurveEx'] = realCurveEx
  part['holes'] = holes
  part['slots'] = slots
  part['sholes'] = sholes
  part['sslots'] = sslots
  part['realRect'] = realRect
  part['edgeInfo'] = edgeInfo
  part['edge_texture_map'] = edgeTextureMap
  part['sholeInfo'] = sholeInfo
  part['sholeInfoF'] = sholeInfoF
  part['sslotInfoF'] = sslotInfoF
  part['sslotInfo'] = sslotInfo
  part['curveHoles'] = curveHoles
  part['millInfo'] = millInfo
  part['oriCurveHoles'] = oriCurveHoles
  part['lightEdgeInfo'] = lightEdgeInfo
  part['model_front_edge'] = model_front_edge
  part['smoothEdge'] = smoothEdge
  part['doorOpenSide'] = doorOpenSide
  part['expandRect'] = expandRect
  part['edgePreMillingInfo'] = edgePreMillingInfo
  part['edgeArrowMap'] = edgeArrowMap
  // if (userChangedList.indexOf(part['plankNum']) === -1)
  //   userChangedList.push(part['plankNum'])

  part = dealPlankHoleSlotCSide([part])[0]

  sholeInfo = generatorSideHoleSlot([
    ...sholes,
    ...holes.filter((hole) => isSideMachineHole(hole) && hole.side == 1),
  ])
  sholeInfoF = generatorSideHoleSlot(
    holes.filter((hole) => isSideMachineHole(hole) && hole.side == -1),
    'upDownFlip'
  )
  sslotInfo = generatorSideHoleSlot(
    [
      ...sslots,
      ...slots.filter((slot) => isSideMachineSlot(slot) && slot.side == 1),
      ...sideMillInfo.filter((mill) => mill.side == '1'),
    ],
    '',
    part
  )
  sslotInfoF = generatorSideHoleSlot(
    slots.filter((slot) => isSideMachineSlot(slot) && slot.side == -1),
    'upDownFlip',
    part
  )
  if (part['finalExtendDisMap']) {
    part['finalExtendDisMap'] = getRotateObject(part['finalExtendDisMap'], 90)
  }

  part['sholeInfo'] = sholeInfo
  part['sholeInfoF'] = sholeInfoF
  part['sslotInfoF'] = sslotInfoF
  part['sslotInfo'] = sslotInfo

  part.mark_rotation = true
  // 合并骨骼门旋转后 原始的 5 块单板也需要旋转
  if (judgeIsMergeFrameDoor(part)) {
    part['frame_door_children'].forEach((child) => rotatePart(child))
  }
}
export function rotatePartInternal(part, source) {
  if (!part) {
    return
  }

  recordTransform(part, 'rotate', 90, source || 'rotatePartInternal')

  var rect = part['rect']
  var oRect = part['oRect']
  var startX = part['startX']
  var startY = part['startY']
  var paths = part['path']
  var srcPath = part['srcPath']
  var unionPaths = part['unionPath']
  var cutCurve = part['cutCurve']
  var cutCurveEx = part['cutCurveEx']
  var realCurve = part['realCurve']
  var realCurveEx = part['realCurveEx']
  var holes = part['holes']
  var slots = part['slots']
  var sholes = part['sholes']
  var sslots = part['sslots']
  var realRect = part['realRect']
  var edgeInfo = part['edgeInfo']
  var sholeInfo = part['sholeInfo']
  var sholeInfoF = part['sholeInfoF']
  var sslotInfoF = part['sslotInfoF']
  var sslotInfo = part['sslotInfo']
  var oPaths = part['oPath']
  var curveHoles = part['curveHoles']
  var millInfo = part['millInfo'] ?? []
  var oriCurveHoles = part['oriCurveHoles']
  let lightEdgeInfo = part['lightEdgeInfo']
  let model_front_edge = part['model_front_edge']
  let doorOpenSide = part['doorOpenSide']
  let smoothEdge = part['smoothEdge']
  var edgeTextureMap = part['edge_texture_map']
  let oldSize = part['oldSize']
  let edgeArrowMap = part['edgeArrowMap']

  // 顺时针旋转

  // 板件中心点
  // var o = Qt.point(rect.width / 2, rect.height / 2);
  var o = {
    x: rect.width / 2,
    y: rect.height / 2,
  }

  // var oo = Qt.point(oRect.width / 2, oRect.height / 2);
  var oo = {
    x: oRect.width / 2,
    y: oRect.height / 2,
  }
  // realRect 中心点（用于 oriPt1, oriPt2）
  var ro = {
    x: realRect.width / 2,
    y: realRect.height / 2,
  }

  // startX\startY
  startX = startX + o.x - rect.height / 2
  startY = startY + o.y - rect.width / 2
  // rect
  // rect = Qt.rect(0, 0, rect.height, rect.width);
  rect = {
    x: 0,
    y: 0,
    width: rect.height,
    height: rect.width,
  }

  oRect = {
    x: 0,
    y: 0,
    width: oRect.height,
    height: oRect.width,
  }

  if (oldSize) {
    oldSize = {
      width: oldSize.height,
      height: oldSize.width,
    }
  }

  // realRect = Qt.rect(0, 0, realRect.height, realRect.width);
  realRect = {
    x: 0,
    y: 0,
    width: realRect.height,
    height: realRect.width,
  }

  // paths
  for (var i in paths) {
    var path = paths[i]
    for (var j in path) {
      var p = path[j]
      var x = p['x'] - o.x
      var y = p['y'] - o.y

      p['x'] = -y + o.y
      p['y'] = x + o.x
    }
  }
  if (srcPath) {
    for (var j in srcPath) {
      var p = srcPath[j]
      var x = p['x'] - o.x
      var y = p['y'] - o.y
      p['x'] = -y + o.y
      p['y'] = x + o.x
    }
  }

  // unionPaths
  for (var i in unionPaths) {
    var path = unionPaths[i]
    for (var j in path) {
      var p = path[j]
      var x = p['x'] - o.x
      var y = p['y'] - o.y

      p['x'] = -y + o.y
      p['y'] = x + o.x
    }
  }

  // paths
  for (var i in oPaths) {
    var path = oPaths[i]
    for (var j in path) {
      var p = path[j]
      var x = p['x'] - oo.x
      var y = p['y'] - oo.y

      p['x'] = -y + oo.y
      p['y'] = x + oo.x
    }
  }

  for (var i in curveHoles) {
    var path = curveHoles[i]['path']
    const nativePath = curveHoles[i]['native_path'] ?? []
    for (var j in path) {
      var p = path[j]
      var x = p['x'] - o.x
      var y = p['y'] - o.y

      p['x'] = -y + o.y
      p['y'] = x + o.x
    }
    for (var j in nativePath) {
      p = nativePath[j]
      x = p['x'] - o.x
      y = p['y'] - o.y
      p['x'] = -y + o.y
      p['y'] = x + o.x
    }
  }
  if (millInfo) {
    for (let i in millInfo) {
      const shape = millInfo[i]['shape']
      for (let j in shape) {
        const p = shape[j]
        const x = p['x'] - oo.x
        const y = p['y'] - oo.y

        p['x'] = -y + oo.y
        p['y'] = x + oo.x
      }
    }
  }

  for (var i in oriCurveHoles) {
    var path = oriCurveHoles[i]['path']
    for (var j in path) {
      var p = path[j]
      var x = p['x'] - oo.x
      var y = p['y'] - oo.y

      p['x'] = -y + oo.y
      p['y'] = x + oo.x
    }
  }

  for (var i in cutCurve) {
    p = cutCurve[i]
    x = p['x'] - o.x
    y = p['y'] - o.y

    p['x'] = -y + o.y
    p['y'] = x + o.x
  }

  for (var i in cutCurveEx) {
    path = cutCurveEx[i]
    for (var j in path) {
      p = path[j]
      x = p['x'] - o.x
      y = p['y'] - o.y
      p['x'] = -y + o.y
      p['y'] = x + o.x
    }
  }

  for (var i in realCurve) {
    p = realCurve[i]

    x = p['x'] - oo.x
    y = p['y'] - oo.y

    p['x'] = -y + oo.y
    p['y'] = x + oo.x
  }

  for (var i in realCurveEx) {
    path = realCurveEx[i]
    for (var j in path) {
      p = path[j]

      x = p['x'] - oo.x
      y = p['y'] - oo.y

      p['x'] = -y + oo.y
      p['y'] = x + oo.x
    }
  }

  // holes

  for (var h in holes) {
    var hole = holes[h]
    var center = hole['center']
    var ocenter = hole['ocenter']

    var x = center['x'] - o.x
    var y = center['y'] - o.y

    center['x'] = -y + o.y
    center['y'] = x + o.x

    var x = ocenter['x'] - oo.x
    var y = ocenter['y'] - oo.y

    ocenter['x'] = -y + oo.y
    ocenter['y'] = x + oo.x
    const newHole = adjustHoleDirection(hole, 90 * 1)
    Object.assign(holes[h], newHole)
  }

  // slots
  for (var s in slots) {
    var slot = slots[s]
    var pt1 = slot['pt1']
    var pt2 = slot['pt2']
    var oriPt1 = slot['oriPt1']
    var oriPt2 = slot['oriPt2']

    var x1 = pt1['x'] - o.x
    var y1 = pt1['y'] - o.y
    var x2 = pt2['x'] - o.x
    var y2 = pt2['y'] - o.y

    pt1['x'] = -y1 + o.y
    pt1['y'] = x1 + o.x
    pt2['x'] = -y2 + o.y
    pt2['y'] = x2 + o.x

    // oriPt1, oriPt2 使用 realRect 坐标系（ro）
    if (oriPt1) {
      var ox1 = oriPt1['x'] - ro.x
      var oy1 = oriPt1['y'] - ro.y
      oriPt1['x'] = -oy1 + ro.y
      oriPt1['y'] = ox1 + ro.x
    }
    if (oriPt2) {
      var ox2 = oriPt2['x'] - ro.x
      var oy2 = oriPt2['y'] - ro.y
      oriPt2['x'] = -oy2 + ro.y
      oriPt2['y'] = ox2 + ro.x
    }

    var opt1 = slot['opt1']
    var opt2 = slot['opt2']

    var x1 = opt1['x'] - oo.x
    var y1 = opt1['y'] - oo.y
    var x2 = opt2['x'] - oo.x
    var y2 = opt2['y'] - oo.y

    opt1['x'] = -y1 + oo.y
    opt1['y'] = x1 + oo.x
    opt2['x'] = -y2 + oo.y
    opt2['y'] = x2 + oo.x
  }

  // sholes
  for (var k in sholes) {
    var shole = sholes[k]
    var side = shole['side']
    var ocenter = shole['ocenter']

    x = ocenter['x'] - oo.x
    y = ocenter['y'] - oo.y
    ocenter['x'] = -y + oo.y
    ocenter['y'] = x + oo.x

    side = parseInt(side) - 1
    if (side <= 0) {
      side = 4
    }

    shole['side'] = side
  }

  // sslots
  for (var j in sslots) {
    var sslot = sslots[j]
    var side = sslot['side']
    var opt1 = sslot['opt1']
    var opt2 = sslot['opt2']

    x1 = opt1['x'] - oo.x
    y1 = opt1['y'] - oo.y
    x2 = opt2['x'] - oo.x
    y2 = opt2['y'] - oo.y

    opt1['x'] = -y1 + oo.y
    opt1['y'] = x1 + oo.x
    opt2['x'] = -y2 + oo.y
    opt2['y'] = x2 + oo.x
    side = parseInt(side) - 1
    if (side <= 0) {
      side = 4
    }

    sslot['side'] = side
  }

  sholeInfo = generatorSideHoleSlot([
    ...sholes,
    ...holes.filter((hole) => isSideMachineHole(hole) && hole.side == 1),
  ])
  sholeInfoF = generatorSideHoleSlot(
    holes.filter((hole) => isSideMachineHole(hole) && hole.side == -1),
    'upDownFlip'
  )
  // 开启 侧孔机加工牛角拉手 需将牛角拉手放到侧槽信息里面
  let sideMillInfo = millInfo.filter((mill) => isSideMachineMillInfo(mill))
  sslotInfo = generatorSideHoleSlot(
    [
      ...sslots,
      ...slots.filter((slot) => isSideMachineSlot(slot) && slot.side == 1),
      ...sideMillInfo.filter((mill) => mill.side == '1'),
    ],
    '',
    part
  )
  sslotInfoF = generatorSideHoleSlot(
    slots.filter((slot) => isSideMachineSlot(slot) && slot.side == -1),
    'upDownFlip',
    part
  )

  // edgeInfo
  var left = edgeInfo.substring(
    edgeInfo.indexOf('←') + 1,
    edgeInfo.indexOf('↓')
  )
  var bottom = edgeInfo.substring(
    edgeInfo.indexOf('↓') + 1,
    edgeInfo.indexOf('→')
  )
  var right = edgeInfo.substring(
    edgeInfo.indexOf('→') + 1,
    edgeInfo.indexOf('↑')
  )
  var top = edgeInfo.substring(edgeInfo.indexOf('↑') + 1)
  edgeInfo = '←' + bottom + '↓' + right + '→' + top + '↑' + left

  // edge_texture_map - 按照与 edgeInfo 相同的旋转逻辑
  if (edgeTextureMap) {
    // 确保数组有4个元素，对应左、下、右、上
    var leftTexture = edgeTextureMap[1] || ''
    var bottomTexture = edgeTextureMap[2] || ''
    var rightTexture = edgeTextureMap[3] || ''
    var topTexture = edgeTextureMap[4] || ''

    // 按照顺时针90度旋转：左→上，下→左，右→下，上→右
    edgeTextureMap[1] = bottomTexture // 新的左 = 原来的下
    edgeTextureMap[2] = rightTexture // 新的下 = 原来的右
    edgeTextureMap[3] = topTexture // 新的右 = 原来的上
    edgeTextureMap[4] = leftTexture // 新的上 = 原来的左
  }
  // edgeArrowMap - 按照与 edgeInfo 相同的旋转逻辑
  if (edgeArrowMap) {
    // 左、下、右、上
    let leftName = edgeArrowMap[0]
    let bottomName = edgeArrowMap[1]
    let rightName = edgeArrowMap[2]
    let topName = edgeArrowMap[3]

    edgeArrowMap[0] = bottomName
    edgeArrowMap[1] = rightName
    edgeArrowMap[2] = topName
    edgeArrowMap[3] = leftName
  }

  lightEdgeInfo = dealEdgeInfoChange(lightEdgeInfo, 'rotate90')
  model_front_edge = dealFormerEdgeChange(
    model_front_edge,
    'rotate90',
    'former'
  )
  smoothEdge = dealFormerEdgeChange(smoothEdge, 'rotate90', 'doorOpenSide')
  doorOpenSide = dealFormerEdgeChange(doorOpenSide, 'rotate90', 'doorOpenSide')

  part['rect'] = rect
  part['oRect'] = oRect
  part['oldSize'] = oldSize
  part['startX'] = startX
  part['startY'] = startY
  part['path'] = paths
  part['srcPath'] = srcPath
  part['unionPath'] = unionPaths
  part['oPath'] = oPaths
  part['cutCurve'] = cutCurve
  part['cutCurveEx'] = cutCurveEx
  part['realCurve'] = realCurve
  part['realCurveEx'] = realCurveEx
  part['holes'] = holes
  part['slots'] = slots
  part['sholes'] = sholes
  part['sslots'] = sslots
  part['realRect'] = realRect
  part['edgeInfo'] = edgeInfo
  part['edge_texture_map'] = edgeTextureMap
  part['sholeInfo'] = sholeInfo
  part['sholeInfoF'] = sholeInfoF
  part['sslotInfoF'] = sslotInfoF
  part['sslotInfo'] = sslotInfo
  part['curveHoles'] = curveHoles
  part['millInfo'] = millInfo
  part['oriCurveHoles'] = oriCurveHoles
  part['lightEdgeInfo'] = lightEdgeInfo
  part['model_front_edge'] = model_front_edge
  part['doorOpenSide'] = doorOpenSide
  part['smoothEdge'] = smoothEdge
  part['edgeArrowMap'] = edgeArrowMap
  // if (userChangedList.indexOf(part['plankNum']) === -1)
  //   userChangedList.push(part['plankNum'])
  if (judgeIsMergeFrameDoor(part)) {
    part['frame_door_children'].forEach((child) => rotatePartInternal(child))
  }
}

function handleLayoutPlans(index) {
  var result = []
  var tmpValue = {}
  var tmpResult = {}
  if (index < 2) {
    tmpResult = layoutPlans[0]
  } else {
    if (layoutPlans.length > 1) {
      tmpResult = layoutPlans[Math.floor(index / 2)]
      index = index % 2
    }
  }

  for (var key in tmpResult) {
    result = result.ggConcat(handlePartialResult(tmpResult[key], index))
  }

  return result
}

function handlePartialResult(partialResult, index) {
  var tmpValue = {}
  var holeInfo = partialResult['holeInfo']
  var dataLst = partialResult['data']
  if (dataLst.length < index + 1) {
    return []
  } else {
    tmpValue = dataLst[index]
    for (var tmpKey in holeInfo) {
      if (tmpValue.hasOwnProperty(tmpKey)) {
        tmpValue[tmpKey]['holes'] = holeInfo[tmpKey]['holes']
      } else {
        tmpValue[tmpKey] = holeInfo[tmpKey]
      }
    }
    if (partialResult['rollCount'])
      rollCount += partialResult['rollCount'][index]
  }
  var retValues = []
  for (var key in tmpValue) {
    retValues.push(tmpValue[key])
  }

  return retValues
}

function getRollCount(layoutResult) {
  var rollCount = 0

  for (var i in layoutResult) {
    var stock = layoutResult[i]
    var parts = stock['parts']

    if (isNeedRoll(parts)) {
      rollCount++
    }
  }

  return rollCount
}

function isNeedRoll(parts) {
  var sp = 0,
    sn = 0
  for (var p in parts) {
    var part = parts[p]
    var holes = part['holes']
    var slots = part['slots']
    var sslots = part['sslots']

    for (var j in holes) {
      var hole = holes[j]
      var hDeep = hole['deep']
      var hSide = hole['side']

      if (hDeep > 0) {
        if (hSide == 1) {
          sp++
        } else {
          sn++
        }
      }
    }

    for (var j in sslots) {
      var sslot = sslots[j]
      var ssDeep = sslot['deep']
      var ssSide = sslot['side']

      if (ssDeep > 0) {
        if (ssSide == 1) {
          sp++
        } else {
          sn++
        }
      }
    }

    for (var j in slots) {
      var slot = slots[j]
      var sDeep = slot['deep']
      var sSide = slot['side']

      if (sDeep > 0) {
        if (sSide == 1) {
          sp++
        } else {
          sn++
        }
      }
    }
  }

  if (sp * sn > 0) {
    return true
  }
  return false
}

function sortTheStock(layoutResult) {
  var allStock = {}
  var curKeys = []

  for (var i in layoutResult) {
    var stock = layoutResult[i]
    var parts = stock['parts']
    var curPlankWidth = stock['plankWidth']
    var curPlankHeight = stock['plankHeight']
    var curKey =
      stock['texture'] + ':' + stock['matCode'] + ':' + stock['thick']

    var area = 0
    for (var p in parts) {
      var part = parts[p]
      var realRect = part['realRect']
      var realW = realRect.width
      var realH = realRect.height

      area += realW * realH
    }
    if (isNeedRoll(parts)) {
      stock['needRoll'] = true
    } else {
      stock['needRoll'] = false
    }

    stock['utilization'] = (area * 100) / (curPlankWidth * curPlankHeight)
    var tmpStocks = []
    if (allStock.hasOwnProperty(curKey)) {
      tmpStocks = allStock[curKey]
      tmpStocks.push(stock)
    } else {
      tmpStocks = []
      tmpStocks.push(stock)
      curKeys.push(curKey)
    }
    allStock[curKey] = tmpStocks
  }
  if (curKeys instanceof Array && curKeys.length > 0) {
    var curLength = curKeys.length
    var sameArr = true
    var tmpcurKeys = globalJSTool.mergeSort(curKeys, 'plankThick', null) //板件分类按厚度排序
    for (var i in curKeys) {
      if (tmpcurKeys.indexOf(curKeys[i]) === -1) {
        sameArr = false
        break
      }
    }
    if (
      tmpcurKeys instanceof Array &&
      tmpcurKeys.length == curKeys.length &&
      sameArr
    ) {
      curKeys = deepCopy(tmpcurKeys)
      var sKey = 0
      var sThick = Number(curKeys[0].split(':')[2])
      for (var j in curKeys) {
        if (
          Number(j) === curKeys.length - 1 ||
          sThick > Number(curKeys[Number(j)].split(':')[2])
        ) {
          var sliceEnd =
            Number(j) === curKeys.length - 1 &&
            sThick === Number(curKeys[Number(j)].split(':')[2])
              ? Number(j) + 1
              : Number(j)
          sThick = Number(curKeys[Number(j)].split(':')[2])
          if (sliceEnd - sKey > 1) {
            var mergeResult = globalJSTool.mergeSort(
              curKeys.slice(sKey, sliceEnd),
              'stockCount',
              allStock
            ) //对已经按厚度排序的板件分类，同一厚度的再按数量排序
            var k = 0
            while (k < sliceEnd - sKey) {
              curKeys.splice(sKey + k, 1, mergeResult[k])
              k++
            }
          }
          sKey = sliceEnd
        }
      }
    } else {
      console.error(
        '---------------------------注意：板件按板厚数量排序失败，恢复初始排序-------------------------'
      )
    }
  }
  layoutResult = []
  purchaseList = []
  for (var i in curKeys) {
    var stocks = allStock[curKeys[i]]
    stocks.sort(function (firstStock, secondStock) {
      var needRollA = firstStock['needRoll']
      var utilizationA = firstStock['utilization']

      var needRollB = secondStock['needRoll']
      var utilizationB = secondStock['utilization']
      if (needRollA === needRollB) {
        return utilizationB - utilizationA
      } else {
        if (needRollA == true) {
          return -1
        }
        return 1
      }
    })

    var paramArr = curKeys[i].split(':')
    var param = {
      //采购单大板信息获取
      thick: paramArr[2],
      color: paramArr[0],
      material: paramArr[1],
      count: stocks.length,
    }

    for (var j in stocks) {
      var needRollA = stocks[j]['needRoll']
      var utilizationA = stocks[j]['utilization']
      layoutResult.push(stocks[j])
      if (stocks[j]['surplusInfo']) {
        param['count'] -= 1
      } else {
        param['spec'] = stocks[j]['plankWidth'] + '*' + stocks[j]['plankHeight']
      }
    }
    purchaseList.push(param)
  }
  return layoutResult
}

function getYunLayoutPercent(oKey, lResult, yResult) {
  var resultData = yResult['result_data']
  if (!resultData) return
  var partsData = resultData[oKey]
  var usedRate = partsData['used_rate']
  var lData = lResult['data']
  for (var i in lData) {
    var part = lData[i]
    var ttt = Object.keys(part)
  }

  for (var u in usedRate) {
    var rates = usedRate[u]
    var stockNum = rates['stock_num']
    var rate = rates['rate']

    var pKey = oKey + ':' + stockNum

    for (var i in lData) {
      var part = lData[i]
      if (part.hasOwnProperty(pKey)) {
        part[pKey]['usedRate'] = rate
        lData[i] = part
        lResult['data'] = lData
      }
    }
  }
}

//判断正/反面是否有孔槽
function hasRevPlankHoleOrSlot(plk, value) {
  var flag = false
  var holes = plk['holes']
  for (var i in holes) {
    var hole = holes[i]
    var side = hole['side']
    if (side === value) {
      flag = true
      break
    }
  }
  if (!flag) {
    var slots = plk['slots']
    for (var i in slots) {
      var slot = slots[i]
      var side = slot['side']
      if (side === value) {
        flag = true
        break
      }
    }
  }
  return flag
}

// 顺时针
const CLOCK_WISE = 1
// 逆时针
const ANTI_CLOCK_WISE = -1

// 顺时针对应的关系
const clockwiseMap = new Map([
  [1, 4],
  [2, 1],
  [3, 2],
  [4, 3],
])
// 逆时针对应的关系
const anticlockwiseMap = new Map([
  [1, 2],
  [2, 3],
  [3, 4],
  [4, 1],
])

// 不同孔方向在旋转时的对应关系
const directionMap = {
  [CLOCK_WISE]: clockwiseMap, // 顺时针
  [ANTI_CLOCK_WISE]: anticlockwiseMap, // 逆时针
}

// 左右翻面(Y轴)时，对调的方向
const flipYMap = new Map([
  [1, 3],
  [3, 1],
])
// 上下翻面(X轴)时，对调的方向
const flipXMap = new Map([
  [2, 4],
  [4, 2],
])

/**
 * 旋转孔的方向
 * @param {*} hole 孔
 * @param {*} angle 旋转角度
 * @param {*} flipDerection 翻面方向 flipX、flipY表示上下和左右翻
 * @returns
 */
export function adjustHoleDirection(hole, angle = 90, flipDerection = '') {
  // 如果角度为0或不是90的倍数,或没有others属性,直接返回
  if (angle % 90 !== 0 || !hole?.others) {
    return hole
  }

  let { direction, obliqueSide } = hole.others
  obliqueSide = Number(obliqueSide)
  /**  1表示顺时针,-1表示逆时针 */
  const rotationType = angle > 0 ? 1 : -1

  // 计算需要旋转多少次90度
  const rotationCount = Math.abs(angle / 90) % 4

  // 多次旋转direction
  let newDirection = direction
  let newObliqueSide = obliqueSide
  // 旋转处理
  for (let i = 0; i < rotationCount; i++) {
    newDirection = directionMap[rotationType].get(newDirection)
    newObliqueSide = directionMap[rotationType].get(newObliqueSide)
  }
  // 左右翻面
  if (flipDerection === 'flipY') {
    const newDir = flipYMap.get(direction)
    const newObliqueDir = flipYMap.get(obliqueSide)
    newDirection = newDir ? newDir : direction
    newObliqueSide = newObliqueDir ? newObliqueDir : obliqueSide
  }
  // 上下翻面
  if (flipDerection === 'flipX') {
    const newDir = flipXMap.get(direction)
    const newObliqueDir = flipXMap.get(obliqueSide)
    newDirection = newDir ? newDir : direction
    newObliqueSide = newObliqueDir ? newObliqueDir : obliqueSide
  }

  return {
    ...hole,
    others: {
      ...hole.others,
      direction: newDirection,
      obliqueSide: newObliqueSide,
    },
  }
}

/**
 * @desc 匹配原片管理下料刀的新规则
 * @param plateknifeInfo 原片管理的材质颜色厚度高光刀等信息
 * @param plankInfo 当前板件的材质颜色厚度高光等信息
 */
export function matchOriginalPlankknife(
  plateknifeInfo,
  plankInfo,
  sourcePriority = 0
) {
  // 处理后端数据
  if (plateknifeInfo.thick === -1) {
    plateknifeInfo.thick = 0
  }
  const plateknifeInfoCopy = Object.assign({}, plateknifeInfo)
  const highlightHandler = new HighlightHandler()
  const fullMatchHandler = new FullMatchHandler()
  const thicknessMatchHandler = new ThicknessMatchHandler()
  const materialMatchHandler = new MaterialMatchHandler()
  highlightHandler
    .setNext(fullMatchHandler)
    .setNext(thicknessMatchHandler)
    .setNext(materialMatchHandler)
  return highlightHandler.handle(plateknifeInfoCopy, plankInfo, sourcePriority)
}

// 高光字段需求分享
class HandlerMatchOriginalPlankknife {
  constructor() {
    this.nextHandler = null
  }
  setNext(handler) {
    this.nextHandler = handler
    return handler
  }
  // 处理者处理方法调用
  handle(plateknifeInfoCopy, plankInfo, sourcePriority) {
    if (this.nextHandler) {
      return this.nextHandler.handle(
        plateknifeInfoCopy,
        plankInfo,
        sourcePriority
      )
    }
    return {
      result: false,
      priority: 0,
      diameter: 0,
      knife: '',
    }
  }
}

// 高光处理者
class HighlightHandler extends HandlerMatchOriginalPlankknife {
  handle(plateknifeInfoCopy, plankInfo, sourcePriority) {
    // 原片管理的材质
    let sourceMatcoede = plateknifeInfoCopy.matCode
    // 当前板件的材质
    let curMatCode = plankInfo.matCode
    // 高光板在code前要加前缀
    if (plateknifeInfoCopy.is_highlight === 1) {
      sourceMatcoede = '高光_' + plateknifeInfoCopy.matCode
    }
    plateknifeInfoCopy.matCode = sourceMatcoede
    plankInfo.matCode = curMatCode
    // 如果原片管理是高光 当前板件材质不带高光则直接不匹配
    if (
      (curMatCode?.slice(0, 3) === '高光_' &&
        plateknifeInfoCopy.is_highlight === 0) ||
      (curMatCode?.slice(0, 3) !== '高光_' &&
        plateknifeInfoCopy.is_highlight === 1)
    ) {
      return {
        result: false,
        priority: 0,
        ...plateknifeInfoCopy,
      }
    }
    return super.handle(plateknifeInfoCopy, plankInfo, sourcePriority)
  }
}

// 材质厚度完全匹配处理者
class FullMatchHandler extends HandlerMatchOriginalPlankknife {
  handle(plateknifeInfoCopy, plankInfo, sourcePriority) {
    if (
      plateknifeInfoCopy.matCode === plankInfo.matCode &&
      plateknifeInfoCopy.thick * 1 === plankInfo.thick * 1 &&
      sourcePriority < 3
    ) {
      return {
        result: true,
        priority: 3,
        ...plateknifeInfoCopy,
      }
    }
    return super.handle(plateknifeInfoCopy, plankInfo, sourcePriority)
  }
}

// 厚度匹配处理者
class ThicknessMatchHandler extends HandlerMatchOriginalPlankknife {
  handle(plateknifeInfoCopy, plankInfo, sourcePriority) {
    let tempMatCode = plateknifeInfoCopy.matCode.trim()
    if (plateknifeInfoCopy.is_highlight) {
      tempMatCode = tempMatCode.replace('高光_', '')
    }
    if (
      plateknifeInfoCopy?.thick * 1 === plankInfo.thick * 1 &&
      !tempMatCode &&
      sourcePriority < 2
    ) {
      return {
        result: true,
        priority: 2,
        ...plateknifeInfoCopy,
      }
    }
    return super.handle(plateknifeInfoCopy, plankInfo, sourcePriority)
  }
}

// 材质匹配处理者
class MaterialMatchHandler extends HandlerMatchOriginalPlankknife {
  handle(plateknifeInfoCopy, plankInfo, sourcePriority) {
    if (
      plateknifeInfoCopy?.matCode === plankInfo.matCode &&
      !Number(plateknifeInfoCopy.thick) &&
      sourcePriority < 1
    ) {
      return {
        result: true,
        priority: 1,
        ...plateknifeInfoCopy,
      }
    }
    return super.handle(plateknifeInfoCopy, plankInfo, sourcePriority)
  }
}
